export default {
  vn: {
    reportCalendarUpdate: 'Cấu hình báo cáo tự động',
    dashboard: 'Tổng quan',
    compare: 'So sánh',
    trending: 'Xu hướng',
    report: 'Báo cáo',
    exportFileReport : 'Xuất báo cáo',
    reportCalendar : 'Tạo lịch báo cáo mới',
    reportList : 'Danh sách báo cáo',
    reportCalendarList : 'Lịch báo cáo',
    manager: 'Quản lý',
    other : 'Khác',
    trialDashboard : 'Dùng thử',
    project : 'Dự án',
    projectList : 'Danh sách dự án',
    createProject : 'Tạo dự án mới',
    updateProject: 'Cấu hình dự án',
    functionList : 'Danh sách chức năng',
    managerKeywords: 'Quản lý từ khoá',
    managerUsers: 'Quản lý tài khoản',
    limitFunction : 'Chức năng giới hạn',
    managerPackages: 'Quản lý gói dịch vụ',
    manageNewspaper: 'Quản lý cấu hình Web',
    manageArticle: 'Quản lý dữ liệu',
    warnings: 'Cảnh báo',
    listWarnings: 'Danh sách cảnh báo',
    messageWarning: 'Tin nhắn cảnh báo',
    registerPackage: 'Đăng ký gói dịch vụ',
    packageDetail: 'Thông tin gói',
    historyRequest: 'Lịch sử yêu cầu',
    sourceData: 'Nguồn dữ liệu',
    groupAccount : 'Tài khoản nhóm',
    personalAccount : 'Tài khoản cá nhân',
    createSourceDataFb: 'Thêm nguồn dữ liệu facebook',
    createSourceDataWebsite: 'Thêm nguồn dữ liệu Website',
    trialJobMange: 'Quản lý nghành nghề dùng thử',
    dataSourceTracking : 'Theo dõi nguồn dữ liệu',
    news: 'Tin bài',
    setting: 'Cài đặt',
    generalSetting:'Cài đặt chung',
    articlesByTopic: 'Tin bài theo chủ đề',
    timeline:'Dòng thời gian',
    isBookMark: 'Đã lưu',
    isSpam: 'Tin rác',
    account: 'Tài khoản',
    password: 'Mật khẩu',
    rePassword: 'Mật khẩu xác nhận',
    organizationName: 'Tên tổ chức',
    city: 'Tỉnh/Thành phố',
    district: 'Quận/Huyện',
    subDistrict: 'Xã/Phuờng',
    houseNumber: 'Số nhà',
    fullAddress: 'Địa chỉ',
    zipCode: 'Zip Code',
    adminAccount: 'Tài khoản admin',
    phoneNumber: 'Số điện thoại',
    organizationType: 'Loại tổ chức',
    streamUrl: 'Link stream',
    firstName: 'Họ',
    lastName: 'Tên',
    birthday: 'Ngày sinh',
    email: 'Email',
    fullName: 'Tên đầy đủ',
    gender: 'Giới tính',
    activeStatus: 'Trạng thái hoạt động',
    functionName: 'Tên chức năng',
    functionAlias: 'Tên hiển thị',
    functionApiPrefix: 'API Path',
    functionScreenPrefix: 'Screen Path',
    metadata: 'Thông tin bổ sung',
    businessPackage: 'Tên gói dịch vụ',
    totalKeyword: 'Số lượng từ khóa',
    totalData: 'Số lượng dữ liệu',
    totalSubAccount: 'Số lượng tài khoản phụ',
    totalDays: 'Số ngày',
    price: 'Giá',
    displayOrder: 'Thứ tự hiển thị',
    topicName: 'Tên chủ đề',
    topicGroupName: 'Tên nhóm chủ đề',
    homeTown: 'Địa chỉ thường trú',
    priority: 'Mức độ ưu tiên',
    groups: 'Nhóm',
    relationship: 'Mối quan hệ',
    type: 'Loại hình',
    url: 'Đường link',
    topic: 'Chủ đề',
    keyword: 'Từ khóa',
    name: "Tên",
    facebookId: "Facebook Id",
    link: "Đường dẫn",
    article: 'Nguồn tin',
    website: 'Tên website',
    time: 'Khoảng thời gian',
    keywordDependent: 'Từ khóa phụ',
    businessTarget: 'Lĩnh vực của bạn',
    oldPassword: "Mật khẩu cũ",
    urlFacebook: 'Nguồn Facebook',
    urlWebsite: 'Nguồn Website',
    expiredDate: 'Ngày hết hạn',
    newPassword:'Mật khẩu mới',
    listSourceFb: 'Danh sách nguồn Facebook',
    listSourceWebsite: 'Danh sách nguồn Website',
    packageData: 'Gói dữ liệu',
    settings: 'Cài đặt',
    download: 'Tải về',
    capacity: 'Dung lượng',
    day: 'ngày',
    informationResource: 'Nguồn tin',
    topNews: 'Top tin bài',
    topDomain: 'Top nguồn',
    sourceSpecial: 'Nguồn đặc biệt',
    totalDataCollected: 'Tổng dữ liệu thu thập',
    add : 'Thêm mới',
    upload: 'Tải lên',
    sampleFile: 'File mẫu',
    tool: 'Công cụ',
    statistics: 'Thống kê',
    all: 'Tất cả',
    onlySupportsUpload: 'Chỉ hỗ trợ file tải lên .xlsx, .xls, .csv',
    onlySupportOneFile: 'Chỉ hỗ trơ tải lên một file!',
    noData: 'Không có dữ liệu',
    createReportError: 'Tạo báo cáo thất bại',
    demoGraphic: 'Nhân khẩu học',
    noPermission: 'Vui lòng nâng cấp tài khoản để sử dụng tính năng',
    manageSpread: 'Độ lan tỏa bài báo',
    manageArticleSpread: 'Biểu đồ thống kê',
    spreadTable: 'Thống kê độ lan tỏa',
    emptyList: 'Danh sách trống',
    manageWorker: 'Quản lý máy chủ',
    manageSystem: 'Quản lý hệ thống',
    checkConfig: 'Kiểm tra cấu hình',
    forDaily: 'Theo ngày',
    forThread: 'Theo tiến trình',

    widget: {
      title: 'Quản lý Widget',
      textDelete: 'Bạn có chắc là muốn xoá thông tin widget: ',
      textSuccess: 'Xoá thành công widget: ',
      create: 'Tạo mới thành công widget',
      update: 'Cập nhật thành công widget',
      createWidget: 'Thêm mới Widget'
    },
    hashtag: {
      search: 'Tìm kiếm',
      topHashtag: 'Top Hashtag đi kèm',
      seeMore: 'Xem thêm',
      share: 'Chia sẻ',
      comment: 'Bình luận',
      result: 'Kết quả',
      download: 'Tải về',
      from: 'Từ',
      post: 'đăng bài',
      numberOfTurns: 'Số lượt',
      recentSearches: 'Tìm kiếm gần đây'
    },
    shareOfVoice: {
     correlation: 'Tương quan lượng tin bài giữa các chủ đề',
     quantity: 'Lượng tin bài nhắc đến',
     correlationOfMentions:'Tương quan lượt nhắc đến giữa các chủ đề theo thời gian',
     shadesOfRatio: 'Tỉ lệ sắc thái của mỗi chủ đề',
     shadesCorrelation: 'Tương quan sắc thái giữa các chủ đề',
     genderOfRation: 'Tỉ lệ giới tính của mỗi chủ đề',
     genderCorrelation: 'Tương quan giới tính giữa các chủ đề',
     agesOfRation: 'Tỉ lệ độ tuổi của mỗi chủ đề',
     agesCorrelation: 'Tương quan độ tuổi giữa các chủ đề',
     male: 'Nam',
     female: 'Nữ',
     other: 'Khác',
     update: 'Cập nhật',
     unChecked: 'Bỏ chọn'
    },

    facebookManager: {
      sentRequestCreate: 'Đã gửi yêu thêm mới nguồn Facebook',
      sentRequestUpdate: 'Đã gửi yêu cập nhật nguồn Facebook'
    },
    dateRangePicker: {
      today: 'Hôm nay',
      yesterday: 'Hôm qua',
      oneWeekAgo: '1 tuần trước',
      oneMonthAgo: '1 tháng trước',
      lastWeek: 'Tuần trước',
      lastMonth: 'Tháng trước',
      threeMonthAgo: '3 tháng trước',
      sixMonthAgo: '6 tháng trước',
      oneYearAgo: '1 năm trước'
    },
    trial : {
      manageJob : 'Quản lý ngành nghề',
      job : 'Ngành Nghề',
      addTopic : 'Thêm chủ đề',
      addKeyword : 'THÊM TỪ KHÓA',
      manage : 'Quản lý',
    },
    warning: {
      emailInvalid: 'Email không hợp lệ: ',
      number: 'Số',
      warningName: 'Tên cảnh báo',
      source: 'Nguồn',
      rules: 'Quy luật',
      formality: 'Hình thức',
      status: 'Tình trạng',
      createdBy: 'Người tạo',
      active: 'Hoạt động',
      inActive: 'Tạm dừng',
      showing: 'Đang hiển thị',
      content: 'nội dung',
      positive: 'Tích cực',
      neutral: 'Trung lập',
      negative: 'Tiêu cực',
      share: 'Chia sẻ',
      comment: 'Bình luận',
      equal: 'bằng',
      lessThan: 'Ít hơn',
      lessThanOrEqual: 'Ít hơn hoặc bằng',
      moreThan: 'Nhiều hơn',
      moreThanOrEqual: 'Nhiều hơn hoặc bằng',
      merge: 'gộp',
      createRulesWarning: 'Tạo quy luật cảnh báo mới',
      updateRulesWarning: 'Cập nhật quy luật cảnh báo',
      filterSmart: 'Lọc thông minh',
      sendMail: 'Gửi đến mail',
      addEmail: 'Thêm một email khác',
      rulesWarning: 'Quy luật cảnh báo',
      project: 'Dự án',
      topic: 'Chủ đề',
      condition: 'Điều kiện',
      createWarning: 'Tạo cảnh báo',
      updateWarning: 'Cập nhật cảnh báo',
      cancel: 'Huỷ',
      allSources: 'Tất cả các nguồn',
      news: 'Báo chí',
      forum: 'Diễn đàn',
      anyPost: 'Bất kỳ bài nào',
      negativeContent: 'Nội dung tiêu cực',
      positiveContent: 'Nội dung tích cực',
      neutralContent: 'Nội dung trung lập',
      totalCollectedPost: 'tổng tin bài thu thập',
      ofAArticle: 'của một tin bài',
      success: 'thành công',
      deleteWarningSuccess: 'Xoá thành công cảnh báo',
      deleteWarning: 'Xoá cảnh báo',
      infomation: 'Thông tin',
      createdDate: 'Ngày tạo',
      recentlyModifited: 'Sửa gần đây',
      copyWarning: 'Sao chép cảnh báo',
      copyWarningSuccess : 'Sao chép thành công cảnh báo',
      editRulesWarning: 'Chỉnh sửa quy luật cảnh báo',
      updateStatusSuccess: 'Cập nhật trạng thái thành công',
      doNotFullInfomation: 'Chưa nhập đầy đủ thông tin'
    },
    source: {
      require: 'Yêu cầu',
      sourceName: 'Tên nguồn',
      url: 'Đường dẫn',
      description: 'Mô tả',
      status: 'Trạng thái',
      newRequire: 'Yêu cầu bởi',
      sourceList: 'Danh sách nguồn',
      active: 'Hoạt động',
      inActive: 'Không hoạt động',
      other: 'Khác',
      profile: 'Trang cá nhân',
      fanpage: 'Trang Facebok',
      group: 'Nhóm Facebook',
      update: 'Cập nhật nguồn',
      create: 'Tạo mới nguồn',
      delete: 'Xoá nguồn',
      showing: 'Đang hiển thị',
      content: 'nội dung',
      enterThePath: 'Nhập đường dẫn',
      close: 'Đóng',
      textSystem: 'Hệ thống sẽ tự điền tên nguồn nếu để trống',
      requireCode: 'Mã yêu cầu',
      sentRequire: 'Đã gửi yêu cầu',
      reject: 'Từ chối',
      newspaper: 'Báo chí',
      news: 'Tin tức',
      placeHolder: 'Nhập tên nguồn dễ nhớ',
      placeHolderDescription: 'Mô tả thêm về nguồn này. (Không bắt buộc)',
      gettingData: "Đang lấy dữ liệu",
      notGettingData: "Ngưng lấy dữ liệu",
      received: 'Đang xử lý yếu cầu',
    },
    overview: {
      tip: 'Gợi ý',
      contentTip: 'Bạn có thể làm hành động A để nhận được B nhanh hơn.',
      data: 'Dữ liệu',
      today: 'Hôm nay',
      comparedToYesterday: 'So với hôm qua',
      viewDataPackages: 'Xem gói dữ liệu',
      topTopic: 'Top chủ đề',
      viewAllTopics: 'Xem tất cả chủ đề',
      hours: 'giờ',
      infomationHighlights: 'Thông tin nổi bật',
      seeMore: 'Xem thêm',
      keyword: 'TỪ KHOÁ',
      shades: 'SẮC THÁI (BETA)',
      interactive: 'Tương tác',
      comment: 'Bình luận',
      share: 'Chia sẻ',
      topic: 'CHỦ ĐỀ',
      project: 'DỰ ÁN',
      post: 'TIN BÀI',
      negative: 'Tiêu cực',
      positive: 'Tích cực',
      neutral: 'Trung lập',
      warning: 'Cảnh báo!',
      greatNews: 'Tin tốt!',
      caution: 'Lưu ý!',
      contentGreat: 'Dữ liệu của bạn có tỉ lệ tích cực tốt.',
      contentWarning: 'Số lượng tin bài tiêu cực tăng nhiều trong 24 giờ qua.',
      contentCaution: 'Số lượng tin bài trung lập tăng nhiều trong 24 giờ qua.',
      numberOfImpressions: 'Số lượng hiển thị'
    },
    //button
    button:{
      downloadData: 'Tải dữ liệu' ,
      quickReportExport: 'Xuất báo cáo nhanh',
      all: 'Tất cả',
      watching: 'Đang xem',
      warningManagement: 'Quản lý cảnh báo',
      newWarning: 'Tạo cảnh báo mới',
      trackingToSpecialNews: 'Theo dõi nguồn tin đặc biệt',
      manageNotificationsAccount : 'Quản lý email nhận cảnh báo',
      shadeRules: 'Quy luật sắc thái',
      deleteAll : 'Xóa tất cả',
      createNew : 'Tạo mới',
      update : 'Cập nhật',
      addAnAccount : 'Thêm mới tài khoản nhận thông báo',
      sendRequire : 'Gửi yêu cầu',
      closed : 'Đóng',
      cancel : 'Hủy',
      copyLink : 'Sao chép liên kết',
      originalPost : 'Bài gốc',
      seeAll : 'Xem tất cả',
      seeMore : 'Xem thêm',
      threshold: 'Thiết lập nhận thông báo'

    },
    //title
    title:{
      readMore: 'Xem thêm',
      readLess: 'Ẩn bớt',
      ages: 'Độ tuổi',
      time: 'Thời gian',
      active: 'Hoạt động',
      shades: 'Sắc thái',
      gender : 'Giới tính',
      feeling: 'Cảm xúc',
      volatility: 'Biến động',
      mentioned: 'Nhắc đến',
      comment: 'Thảo luận',
      lastPeriod: 'Kỳ trước',
      shadesBySocial: 'Sắc thái (BETA) theo kênh',
      topic: 'Chủ đề',
      positive: 'Tích cực',
      negative: 'Tiêu cực',
      neutral: 'Trung lập',
      share: 'Chia sẻ',
      content: 'Nội dung',
      interactive:'Tương tác'
    },
    dashboardAnalytics : {
      positive : 'Tích cực',
      neutral : 'Trung lập',
      negative : 'Tiêu cực',
      content : 'Nội dung',
      socialNetwork : 'Mạng xã hội',
      electronicMedia : 'Báo điện tử',
      otherSources : 'Nguồn khác',
      forumOtherSources : 'Forum & Nguồn tin khác',
      numberOfPost : 'Số bài viết',
      onlineNewspaper : 'Báo online',
      textSuccess : 'Tải dữ liệu thành công',
      textPackage : 'Bạn đang chưa sử dụng gói dịch vụ nào !',


    },
    generalSettingMenu:{
      isCurrentDevice:'Trên thiết bị này',
      addressLogIn : 'Nơi bạn đã đăng nhập',
      Unknown : 'Không xác định',
      logOut : 'Đăng xuất thiết bị',
      textLogOut : 'Bạn có muốn đăng xuất thiết bị',
      logOutSuccess : 'Đăng xuất  thành công thiết bị',
      btn1:'Thông tin tổ chức',
      btn2:'Thông báo',
      btn3:'Hiển thị',
      btn4:'Điều khoản',
      btn5:'Phiên bản',
      btn6:'Đăng xuất',
      textLabel:'Nhận thông báo tài khoản và hóa đơn',
      language:'Ngôn ngữ',
      vn:'Tiếng việt',
      textNoti:'Thông báo cho phép bạn nắm bát được các biến động đối với các dữ liệu của bạn kịp thời để bạn có thể nhanh chóng phản ứng với các thay đổi này',
      content:'Nội dung chung',
      warning:'Cảnh báo',
      titileBtn4:'Điều khoản sử dụng',
      labelBtn4:'Phiên bản hiện tại',
      labelDate:'Ngày cập nhập',
      changepass:'Thay đổi mật khẩu',
      textBtn5:'Info247 là một sản phẩm công nghệ của Công ty TNHH DeepBlue Technology',
      acc:'Trên thiết bị này',
      minuteAgo:'phút trước',
      hoursAgo:'giờ trước',
      daysAgo:'ngày trước',
      lastMonth:'tháng trước',
      justNow:'vừa xong'
    },
    compareBranding:{
      selectCompare:'Chọn để so sánh',
      compare: 'So sánh thương hiệu',
      save: 'Tải về',
      selection: 'Chọn',
      selectionCompareBranding: 'So sánh thương hiệu',
      topicOther: 'Chủ đề khác',
      numberOfMentions: 'Lượt nhắc đến',
      allOfChannel: 'Tất cả các kênh',
      newsChannel: 'Kênh tin tức',
      addCompare: 'THÊM MỚI',
      textAmount : 'Vượt quá số lượng so sánh',
      textPosition : 'Vị trí ghim không hợp lệ',
      textTheme : 'chủ đề thành công:',
      pin : 'Ghim',
      unpin : 'Hủy ghim',
      textSuccess : 'thành công chủ đề',
      textChoose : 'Chủ đề so sánh đã được chọn',
      textReport : 'Xuất báo cáo thành công',
      textTop5 : 'Top 5 từ ý nghĩa đi kèm với thương hiệu',


    },
    managermentTrending:{
      facebookName: 'Tên nguồn Facebook',
      contentTrending: 'Xu hướng nội dung',
      refresh: 'Cập nhật',
      keywordMentions: 'Từ khoá được nhắc tới nhiều',
      TrendingsMentionInSocial: 'Các xu hướng được nhắc tới nhiều trên mạng xã hội',
      value:'Giá trị',
      trendDevelopment:'Diễn biến xu hướng',
      contentMentioned:'Nội dung nhắc tới',
      totalInteractiveContent:'TỔNG SỐ NỘI DUNG TƯƠNG TÁC',
      totalNumber:'Tổng số lần nhắc tới',
      post:'Bài đăng',
      interactive:'Tương tác',
      titleChart:'THỐNG KÊ TẦN SUẤT XUẤT HIỆN',
      titleTable:'Top nguồn đăng Website',
      webName:'Tên nguồn Website',
      interactionOccupies:'Tương tác chiếm',
      posts:'Số bài viết',
      nameFace:'Tên nguồn Facebook',
      titleTableFace:'Top nguồn Facebook'
    },
    exportFile: {
      textSuccessDelete : 'Xóa thành công báo cáo',
      apply : 'Áp dụng',
      titleDownloadPooled : 'Xác nhận tải xuống gộp',
      textDownloadPooled : 'Bạn có chắc thực hiện hành động tải xuống gộp báo cáo ?',
      titleCopyPooled : 'Xác nhận sao chép gộp',
      textCopyPooled : 'Bạn có chắc thực hiện hành động sao chép gộp báo cáo ?',
      titleDeletePooled : 'Xác nhận xóa gộp',
      textDeletePooled : 'Bạn có chắc thực hiện hành động xóa gộp báo cáo ?',
      errPooled : 'Chọn ít nhất một báo cáo',
      downloadCheckbox : 'Tải xuống các lựa chọn',
      copyCheckbox : 'Sao chép các lựa chọn',
      deleteCheckbox : 'Xóa các lựa chọn',
      hours : 'giờ',
      week : 'Hàng tuần',
      continue : 'Tiếp tục',
      pause : 'Tạm dừng',
      auto : ' chạy báo cáo tự động',
      deleteSuccess : 'Xóa thành công báo cáo',
      copySuccess : 'Sao chép báo cáo thành công',
      daily : 'giờ Hàng ngày',
      deleteReport : 'Xác nhận xóa',
      textDelete : 'Bạn muốn xóa báo cáo',
      updateSuccess: 'Cập nhật báo cáo thành công',
      createSuccess : 'Tạo lịch báo cáo mới thành công',
      stt : 'SỐ',
      topicList : 'CÁC CHỦ ĐỀ',
      nameExport : 'TÊN BÁO CÁO',
      creator : 'NGƯỜI TẠO',
      status : 'TÌNH TRẠNG',
      calendar : 'LỊCH BÁO CÁO',
      action : 'HÀNH ĐỘNG',
      createDate : 'NGÀY TẠO',
      edit : 'Chỉnh sửa lịch báo cáo',
      copy : 'Sao chép lịch báo cáo',
      delete : 'Xóa lịch báo cáo',
      number :'Số lượng hiển thị ',
      endDate : 'Chọn một khoảng thời gian',
      monday : 'Thứ Hai',
      tuesday : 'Thứ Ba',
      wednesday : 'Thứ Tư',
      thursday : 'Thứ Năm',
      friday : 'Thứ Sáu',
      saturday : 'Thứ Bảy',
      sunday : 'Chủ Nhật',
      createReportCalendar : 'Tạo lịch báo cáo',
      sendEmailTime : 'Gửi email trước khi báo cáo này hết hạn',
      typesReport: 'Loại báo cáo',
      exportReport: 'Xuất báo cáo',
      brandHealthByDay: 'Sức khoẻ thương hiệu ngày',
      brandHealthByWeek: 'Sức khoẻ thương hiệu tuần',
      brandHealthByVNPost: 'Sức khoẻ thương hiệu Vnpost',
      postFb : 'Bài viết Facebook',
      commentFb : 'Bình luận Facebook',
      postIg : 'Bài viết Instagram',
      commentIg : 'Bình luận Instagram',
      news : 'Tin tức',
      textReport : 'Chưa chọn loại báo cáo',
      topic: 'Chủ đề:',
      source: 'Nguồn:',
      textSuccess : 'Xuất báo cáo thành công',
      report : 'Tạo báo cáo',
      newReport : 'Tạo báo cáo mới',
      nameReport : 'Tên báo cáo ',
      typeReport : 'Loại báo cáo  ',
      contentReport : 'Nội dung của báo cáo : ',
      dataRange : 'Phạm vi dữ liệu:',
      cancel : 'Hủy',
      exportFile : 'Xuất báo cáo',
      reportName : 'Tên báo cáo',
      all : 'Tất cả',
      contentConfiguration : 'Cấu hình nội dung Email',
      sendEmail : 'Gửi email',
      sendFile : 'Gửi file báo cáo đính kèm',
      place : 'Nhập tên báo cáo',
      sendTo : 'Gửi đến',
      sendToEmail : 'Gửi email',
      fileReport : 'Đính kèm file báo cáo',
      title : 'Tiêu đề',
      content : 'Nội dung',
      reportCalendar : 'Tạo lịch báo cáo',
      autoReport : 'Thiết lập báo cáo tự động',
      editReportCalendar : 'Cấu hình báo cáo tự động',
      update : 'Cập nhập',
      frequency : 'Tần suất',
      time : 'Thời điểm',
      endTimeReport : 'Thời điểm kết thúc báo cáo',
      placeTime : 'Chọn thời điểm',
      project : 'Dự án',
      uploadListSources: 'Tải lên danh sách nguồn',
      requiredFile: 'File định dạng',
      dragAndDropFileOrChoseFile: 'Kéo thả file vào đây hoặc bấm để chọn file',
      validateEmail: 'Email không hợp lệ'
    },
    userView:{
      Email: 'Email',
      userName: 'Tên người dùng',
      phoneNumber: 'Số điện thoại',
      organization: 'Tổ chức',
      birthDate: 'Ngày sinh',
      address: 'Địa chỉ',
      userInfomation: 'Thông tin tài khoản',
      edit: 'Chỉnh sửa',
      changePassword: 'Đổi mật khẩu',
      registerNotify: 'Đăng ký nhận thông báo',
      infomation: 'Thông tin',
      logOut: 'Đăng xuất'
    },
    articleTimeLine:{
      post:'TIN BÀI',
      postLink:'Xem tin bài của ngày này',
      projectNotTopic:'Dự án không có chủ đề',
    },
    articleDetail:{
      private:'Nhóm kín',
      result:'Kết quả',
      articlesByTopic:'Tin bài theo chủ đề',
      at: 'Lúc',
      from: 'Từ',
      contentMention: 'Nội dung đề cập',
      pages: 'Trang',
      views: 'Hiển thị',
      content: 'Nội dung',
      filter: 'Bộ lọc',
      sort: 'Sắp xếp theo',
      shades: 'Sắc thái (BETA)',
      filterByFeeling: 'Lọc theo cảm xúc',
      source: 'Nguồn',
      topic: 'Chủ đề',
      newsFeed: 'Mới nhất',
      newsOld: 'Cũ nhất',
      ascendingLevel: 'Tương tác tăng',
      decreaseLevel: 'Tương tác giảm',
      all: 'Tất cả',
      findByKeyword: 'Tìm theo từ khoá...',
      postFacebook: 'Bài viết Facebook',
      commentFacebook: 'Bình luận Facebook',
      facebookComment: 'Bình luận facebook',
      postIg : 'Bài viết Instagram',
      commentIg : 'Bình luận Instagram',
      news: 'Tin tức',
      shadesContent: 'Sắc thái nội dung',
      share: 'Chia sẻ',
      copy: 'Sao chép',
      origin: 'Bài gốc',
      spam: 'Tin rác',
      save: 'Lưu tin',
      savePost: 'Lưu bài viết',
      unSavedChanges: 'Bỏ lưu tin',
      findOrigin: 'Mở bài viết gốc',
      priorityLevel: 'Mức độ ưu tiên',
      markSpam: 'Đánh dấu tin rác',
      notSpam: 'Không phải tin rác',
      optionsShade: 'Tuỳ chọn sắc thái',
      positive: 'Tích cực',
      negative: 'Tiêu cực',
      neutral: 'Trung lập',
      update: 'Cập nhật không thành công'
    },
    articleBookmark:{
      selectAll:'Chọn tất cả',
      project: 'Dự án',
      savedContents: 'Tin đã lưu',
      topics: 'Chủ đề',
      sort: 'Sắp xếp',
      sources: 'Nguồn',
      time: 'Thời gian' ,
      filterByShades: 'Lọc theo cảm xúc',
      filterByKeyword: 'Lọc theo từ khoá...',
      news: 'Tin tức',
      postFacebook: 'Bài viết facebook',
      commentFacebook: 'Bình luận facebook',
      facebookComment: 'Bình luận facebook',
      all: 'Tất cả',
      exportToFile: 'Xuất báo cáo',
      shadesContent: 'Sắc thái nội dung',
      comment: 'Bình luận',
      share: 'Chia sẻ',
      copy: 'Sao chép',
      origin: 'Bài gốc',
      spam: 'Tin rác',
      saveContent: 'Lưu tin',
      unSaveContent: 'Bỏ lưu tin',
      filter: 'Bộ lọc',
      restore: 'Khôi phục',
      titleTick : 'Đánh dấu tin rác',
      textTick : 'Bạn có chắc là tin rác',
      acceptText : 'Xác nhận',
      cancelText : 'Hủy',
      textCopy : 'Sao chép đường dẫn thành công',
      acceptText1 : 'Đánh dấu',
      like : 'Thích',
      love : 'Yêu thích',
      wow : 'Ngạc nhiên',
      care : 'Thương thương',
      sad : 'Buồn',
      angry : 'Phẫn nộ',
      textSave : 'Cập nhật lưu tin thành công',
      rejectPost: 'Huỷ lưu tin thành công',
      textUnsave : 'Cập nhật lưu tin không thành công',
      seveNotDone:'Lưu tin không thành công',
      textDlData : 'Tải dữ liệu thành công',
      textRecovery : 'Khôi phục tin thành công',
      positive : 'Tích cực',
      negative : 'Tiêu cực',
      neutral : 'Trung lập',
      titleRecovery : 'Khôi phục tin',
      textRecovery2 : 'Bạn có muốn khôi phục lại ? ',
      textTl : 'Bài viết hiện tại được đánh giá trung lập',
      textTc : 'Bài viết hiện tại đang được đánh giá tiêu cực',
      textTchc : 'Bài viết hiện tại đang được đánh giá tích cực',
      isSpamSuccess : 'Đánh dấu tin rác thành công',
      isSpamUnSuccess : 'Đánh dấu tin rác không thành công'


    },
    warningManager : {
      notifyUpdateSucces:'Cập nhật quy luật sắc thái thành công',
      warning : 'Cảnh báo',
      list : 'Danh sách',
      searchWarningContent :'Tìm kiếm nội dung cảnh báo',
      status : 'Trạng thái : ',
      category : 'DANH MỤC',
      allWarning : 'TẤT CẢ CẢNH BÁO',
      statusAll : 'Tất cả',
      statusRead : 'Tin đã đọc',
      statusUnread : 'Tin chưa đọc',
      contentWarning : 'NỘI DUNG',
      setUp : 'Thiết lập nội dung và tần suất nhận cảnh báo',
      listWarning : 'Danh sách cảnh báo',
      frequency : 'Tần suất',
      manipulation : 'Thao tác',
      warningByContentShade : 'Cảnh báo theo sắc thái nội dung',
      sendMe : 'Gửi cho tôi',
      whenCollected : 'Khi bất cứ nội dung thu thập được là',
      newsPapers : 'Báo chí',
      other : 'Khác',
      rightAway : 'Ngay lập tức',
      collectedContent : 'Nội dung thu thập',
      timeWarning : 'Thời gian cảnh báo',
      contentWarningInfo : 'Nội dung cảnh báo',
      back : 'Quay lại',
      selectTime : 'Chọn thời gian cảnh báo',
      newSource : 'Thêm mới nguồn tin',
      source : 'Nguồn tin',
      note : 'Chú thích',
      updateSource : 'Cập nhật nguồn tin',
      createNewSource : 'Tạo mới nguồn tin',
      emailGetNotify : 'Email nhận thông báo',
      importEmail : 'Nhập email nhận thông báo và nhấn enter',
      textEmailEmpty : 'Email không được để trống',
      textEmailInvalidate : 'Email không đúng định dạng',
      textEmailWasRegistered  : 'Email đã được đăng ký nhận thông báo',
      textSuccessfulNotification : 'Thêm mới tài khoản nhận thông báo thành công',
      textShadeRules : 'Việc thiết lập đánh giá tích cực, tiêu cực giúp hệ thống tự động đánh giá chính xác hơn. Bạn có thể nhập từ ngữ xác định trạng thái bài viết, bao gồm: các tính từ mô tả trạng thái, các từ ngữ thể hiện sắc thái cảm xúc đặc thù liên quan tới tính chất sự việc của nội dung.',
      autoEvaluate : 'Tự động đánh giá',
      positiveWords : 'Từ ngữ tích cực',
      negativeWords : 'Từ ngữ tiêu cực',
      importAndPress : 'Nhập từ, cụm từ rồi nhấn enter',
      deleteAllWarning : 'Xóa tất cả cảnh báo',
      remindDelete : 'Bạn có chắc là muốn xóa tất cả cảnh báo ?',
      textDeleteAll : 'Đã xóa tất cả cảnh báo',
      textNotDeleteAll : 'Chưa thể xóa tất cả cảnh báo',
      textCopy : 'Sao chép đường dẫn thành công',
      notification : 'Thông báo',
      negativeNews : 'Tin tiêu cực',
      generalNotification : 'Thông báo chung',
      allNotification : 'Tất cả thông báo ',
      timeNotification : 'Thời gian',
      contentNotification : 'Nội dung',
      newWarning : 'Cảnh báo mới',
      allWarningMessage : 'Tất cả cảnh báo',
      storageWarning : 'Lưu trữ cảnh báo',
      textStorageWarning : 'Lưu trữ thông báo thành công',
      after15 : 'Sau 15 phút',
      after30 : 'Sau 30 phút',
      after60 : 'Sau  1 tiếng',
      textNotifi : 'Thiết lập thông báo thành công',
      textDelete : 'Xóa email nhận thông báo',
      titleDelete : 'Xác nhận xóa',
      textDeleAccount : 'Bạn có chắc là muốn xóa tài khoản',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      action : 'Hành động',
      titlePercent : 'Thiết lập ngưỡng phần trăm tiêu cực',
      textSource : 'Nguồn tin không được để trống',
      add : 'Thêm mới',
      update : 'Cập nhật',
      success  :'thành công',
      textDeleteSource : 'Xóa nguồn tin thành công',
      textDelete2 : 'Bạn có chắc là muốn xóa nguồn tin',
      text1 : 'Chọn ít nhât một nguồn nội dung',
      text2 : 'Chọn ít nhât một sắc thái',
      text3 : 'cảnh báo thành công',
      text4 : 'cảnh báo thất bại',
      text5 : 'Xóa cảnh báo thành công',
      text6 : 'Xóa cảnh báo thất bại',
      text7 : 'Bạn có chắc là muốn xoá cảnh báo',
      text8 : 'Lưu thông báo thành công',
      transactions: 'Hành động'


    },
    managerKeyword: {
      managerKeywordTitle: 'Quản lý từ khóa',
      addNewCampaign: 'Thêm mới chiến dịch',
      otherTopics: 'Các chủ đề khác',
      titleShare: 'Chia sẻ nhóm chủ đề này đến người dùng khác',
      combinedAction: 'Hành động gộp',
      combinedActionPlaceholder: 'Chọn hành động gộp',
      campaignUpdate: 'Cập nhật chiến dịch',
      deleteCampaign: 'Xóa chiến dịch',
      share: 'Chia sẻ',
      addNewTopic: "Thêm mới chủ đề",
      topic: 'Chủ đề',
      update : 'Cập nhật',
      keyword: 'Từ khóa',
      informationResource: 'Nguồn tin',
      dateCreated: 'Ngày tạo',
      creator: 'Người tạo',
      action: 'Hành động',
      notAcceptedYet: 'Chưa chấp nhận',
      your: 'của bạn',
      other: 'Khác',
      rival: 'Đối thủ',
      all: 'Tất cả',
      sharedBy: 'Chia sẻ bởi',
      shareThisThread: 'Chia sẻ chủ đề này',
      accept: 'Chấp nhận',
      refuse: 'Từ chối',
      changeTheme: 'Thay đổi chủ đề',
      hideTopic: 'Ẩn chủ đề',
      showTopic: 'Ẩn chủ đề',
      bookmarkTopicsAsFavorites: 'Đánh dấu chủ đề yêu thích',
      removeFavoriteTopic: 'Bỏ chủ đề yêu thích',
      deleteTopic: 'Xóa chủ đề',
      copyTheme: 'Sao chép chủ đề',
      changeTheSubject: 'Chuyển chủ đề',
      turnOffNoti: 'Tắt thông báo',
      turnOnNoti: 'Bật thông báo',
      placeholderAction: 'Chọn hành động gộp',
      addTitle: 'Thêm chiến dịch',
      updateTitle: 'Chỉnh sửa chiến dịch',
      nameCampaign: 'Tên chiến dich',
      spanPopup:'Bạn có thể bổ sung thêm chủ đề và từ khóa sau khi tạo mới nhóm này',
      btnUpdate:'Cập nhật',
      btnCreate:'Tạo mới',
      close:'Đóng',
      switchGroupsTopic:'Di chuyển chiến dịch',
      placeSelect:'Chọn chiến dịch',
      back:'Quay lại',
      spanText:'Một chủ đề có thể bao gồm nhiều từ khóa chính',
      topicName:'Tên chủ đề',
      topicTo:'Chủ đề này liên quan đến',
      you:'Bạn',
      spanText1:'Tất cả thông tin thu thập sẽ gồm từ khóa này dưới đây. Các từ khóa phụ hỗ trợ việc thu thập thông tin được chính xác hơn',
      mainKey:'Từ khóa chính',
      subKey:'Từ khóa phụ',
      placeInput:'Tên thương hiệu, Sản phẩm, Chiến dịch, Các vấn đề cần theo dõi ....',
      placeSubKey:'Đặc điểm thuộc tính của từ khóa chính',
      addKey:'Thêm từ khóa',
      deleKey:'Xóa từ khóa',
      removeKey:'Từ khóa loại bỏ',
      spanText2:'Tất cả thông tin thu thập sẽ',
      extrude:'loại bỏ',
      spanText3:'các nội dung có chứa các từ khóa sau',
      placeText:'Tin bài chứa các từ khóa spam, rác sẽ không được thu thập.',
      shareKey:'Chia sẻ chiến dịch',
      emailShare:'Email chia sẻ',
      boxShare : 'Chia sẻ các lựa chọn',
      boxCopy : 'Sao chép các lựa chọn',
      boxMove : 'Di chuyển các lựa chọn',
      boxCompare : 'So sánh các lựa chọn',
      boxDelete : 'Xóa các lựa chọn',
      show : 'Hiện',
      hide : 'Ẩn',
      textTheme : 'chủ đề thành công',
      turnOn : 'Bật',
      turnOf : 'Tắt',
      textNotifi : 'thông báo thành công',
      textRefuse : 'Từ chối chủ đề chia sẻ :',
      textShare : 'Chia sẻ thành công',
      textAdd : 'thành công chủ đề',
      textKeyword : 'Từ khóa chính không được để trống',
      textKeyword2 : 'Từ khóa chính không được trùng với từ khóa loại trừ.',
      textSource : 'Phải chọn ít nhất một nguồn tin',
      textTheme2 : 'Chủ đề không được để trống',
      add : 'Thêm',
      textTheme3 : 'Chủ đề có ít nhất 1 từ khóa',
      textLength : 'Độ dài vượt quá 20 ký tự',
      titleCampaign : 'Xác nhận chiến dịch',
      textDeleteCampaign : 'Bạn có chắc xóa chiến dịch',
      acceptText : 'Xác nhận',
      cancelText : 'Hủy',
      deleted : 'Đã xóa',
      textDeleteSuccess : 'Xóa thành công chiến dịch',
      textMoveSuccess : 'Chuyển chủ đề thành công',
      textTheme4 : 'Vui lòng chọn ít nhất 1 chủ đề',
      titlePooledShare : 'Xác nhận chia sẻ gộp',
      textPooledShare : 'Bạn có chắc thực hiện hành động chia sẻ gộp ?',
      titlePooledCopy : 'Xác nhận sao chép gộp',
      textPooledCopy : 'Bạn có chắc thực hiện hành động sao chép dữ liệu gộp ?',
      titlePooledMove : 'Xác nhận di chuyển gộp',
      textPooledMove : 'Bạn có chắc thực hiện hành động di chuyển gộp ?',
      titlePooledDelete : 'Xác nhận xóa gộp',
      textPooledDelete : 'Bạn có chắc thực hiện hành động xóa gộp ?',
      titlePooledCompare : 'Xác nhận so sánh gộp',
      textPooledCompare : 'Bạn có chắc thực hiện hành động so sánh gộp ?',
      textShareThemeSuccess : 'Chia sẻ chủ đề thành công',
      textDele : 'Xóa thành công các lựa chọn',
      textFavourite : 'chủ đề yêu thích thành công',
      textDeleSuccess : 'Xóa chủ đề thành công',
      titleDelete : 'Xác nhận xóa',
      textFavorite : 'Bạn muốn đánh dấu chủ đề yêu thích',
      textDelete : 'Bạn có chắc là muốn xóa chủ đề :',
      delete : 'Xóa',
      textCopy : 'Sao chép thành công chủ đề',
      textCampaign : 'Chiến dịch không được để trống',
      textCampaign2 : 'Chiến dịch tối đa 100 kí tự',
      textCampaign3 : 'thành công chiến dịch',
      btnPreview: 'Xem trước',
      notEstimate: 'Chưa ước tính',
      cannotEstimate: 'Không thể ước tính',
      dataLast30Days: 'Dữ liệu 30 ngày gần nhất',
      dataLast7Days: 'Dữ liệu 7 ngày gần nhất',
      dataLast3Days: 'Dữ liệu 3 ngày gần nhất',
      avgTime: 'Thời gian trung bình có dữ liệu',
      posts: 'Tin bài',
      minute: 'phút',
      priority: 'Mức độ ưu tiên',
      priorityLevelSuccess: 'Cập nhật mức độ ưu tiên thành công',
      priorityLevelReject: 'Mức độ ưu tiên không vượt quá 50'

    },
    accountUser:{
      changepass:'Thay đổi mật khẩu',
      continue : 'Tiếp tục',
      textChangePassword : 'Nếu bạn cho rằng ai đó có thể biết mật khẩu cũ của mình, bạn nên đăng xuất khỏi mọi điện thoại, máy tính.',
      logOut : 'Đăng xuất tất cả các thiết bị',
      maintain : 'Duy trì đăng nhập',
      textSuccessMaintain : 'Đã cập nhập mật khẩu và duy trì đăng nhập',
      textLogOut : 'Đăng xuất thành công tất cả các thiết bị',
      notifySucces:'Cập nhật mật khẩu thành công',
      titleAccountUser:'Quản lý tài khoản',
      btnAddAcc:'Thêm tài khoản',
      search:'Tìm kiếm ....',
      nameUser:'Tên người dùng',
      fullName:'Tên đầy đủ',
      phoneNum:'Số điện thoại',
      sex:'Giới tính',
      birthday:'Ngày sinh',
      statusUser:'Trạng thái hoạt động',
      passUser:'Mật khẩu',
      confirmPass:'Xác nhận mật khẩu',
      city:'Tỉnh/Thành phố',
      district:'Quận/Huyện',
      spanNoOption:'Không có giá trị hợp lệ nào',
      subDistrict:'Xã/Phường',
      houseNumber:'Số nhà',
      address:'Địa chỉ',
      updateUser:'Cập nhật ',
      createUser:'Tạo mới',
      backUser:'Quay lại',
      actionUser:"Hành động",
      titleDele:'Xác nhận xóa',
      textDele:'Bạn có chắc là muốn xóa tài khoản',
      acceptText:'Xoá',
      cancelText:'Huỷ',
      text1:'Xoá tổ chức thành công',
      unActive:'Chưa kích hoạt',
      active:'Hoạt động',
      lock:'Khóa',
      otherUser:'Khác',
      male:'Nam',
      female:'Nữ',
      unActiveUsers:'Chưa kích hoạt',
      activeUsers:'Hoạt động',
      lockUser:'Bị khóa',
      btnUpdate : 'Cập nhật',
      btnAdd : 'Thêm',
      textSuccess : 'tài khoản thành công',
      deleteAccountSuccess: 'Xoá tài khoản thành công',
      account : 'Tài khoản',
      img : 'Ảnh đại diện',
      editImg : 'Thay ảnh',
      editProfile : 'Chỉnh sửa thông tin',
      displayName : 'Tên hiển thị',
      desDisplayName : 'Hiển thị trong các chức năng',
      organizationName : 'Tên tổ chức',
      desOrganizationName : 'Tên tổ chức của người dùng',
      email : 'Email',
      desEmail : 'Dùng để đăng nhập và thông báo',
      phoneNumber : 'Điện thoại',
      desPhoneNumber : 'Gửi thông báo và xác thực',
      editPassword : 'Thay đổi mật khẩu',
      desEditPassword : 'Tài khoản chủ có quyền thay đổi đối với các tài khoản dưới quyền được tạo bởi tài khoản chủ.',
      addPassword : 'Tạo mật khẩu mới',
      add : 'Tạo mới',
      updateImg : 'Cập nhật ảnh đại diện',
      back : 'Quay lại',
      update : 'Cập nhật',
      titlePassword : 'Đổi mật khẩu mới',
      newPassword : 'Mật khẩu mới',
      desNewPassword : '6-12 ký tự, bao gồm chữ, số và chữ viết hoa',
      saveChanges : 'Thay đổi mật khẩu',
      close : 'Đóng',
      editPasswordSuccess : 'Cập nhật mật khẩu thành công',
      textImg : 'Bạn chưa chọn ảnh đại diện',
      deleteAccount : 'Xóa tài khoản',
      desDeleteAccount : 'Xoá tài khoản của thành viên sẽ loại bỏ tài khoản này khỏi danh sách các thành viên và dừng mọi truy cập và quyền hạn của tài khoản này đối với các dữ liệu đã tạo ra trong phạm vi quản lý của tài khoản chủ.',
      delete : 'Xóa',
      list : 'Danh sách thành viên',
      addList : 'Thêm thành viên',
      updatePassword : 'Cập nhật mật khẩu thành công',
      doNotDelete : 'Không thể xóa tài khoản trưởng nhóm'


    },
    packageUpgrade:{
      limit:'Giới hạn',
      numberFolow:'Số lượng từ khóa theo dõi',
      keyword:'từ khóa',
      numberSubKey:'Số lượng từ khóa phụ',
      dayUser:'Ngày sử dụng',
      limitData:'Giới hạn dữ liệu',
      createAcc:'Tạo tài khoản phụ',
      yes:'Có',
      no:'Không',
      cost:'Chi phí',
      vnd:'đồng',
      feature:'Tính năng',
      request:'Yêu cầu',
      titlePackage : 'Gửi yêu cầu đăng ký gói',
      text1 : 'Bạn đã đăng ký gói',
      text2 : 'vui lòng chờ phê duyệt',
      acceptText : 'Về trang yêu cầu',
      cancelText : 'Đóng',
      text3 : 'của bạn sẽ hết hạn vào',
      text4 : 'của bạn đã hết hạn. Để tiếp tục theo dõi dữ liệu mới, hãy gia hạn gói cước ngay.',
      titleSuccess : 'Gửi yêu cầu thành công',
      text5 : 'Yêu cầu của bạn đã được gửi tới đội ngũ chăm sóc khách hàng.\n' +
        'Chúng tôi sẽ sớm xử lý và liên hệ lại với bạn. \n',
      receive : 'Tiếp nhận',
      agree : 'Đồng ý',
      refuse : 'Từ chối',
      cancelled : 'Đã hủy',
      //data
      theWholeAccount: 'Toàn tài khoản',
      inAMonth: 'Trong một tháng',
      account: 'Tài khoản',
      packageData: 'Gói dữ liệu',
      present: 'Hiện tại',
      toDay: 'hôm nay',
      data: 'Dữ liệu',
      thisPeriod: 'Kỳ này',
      remaining: 'Còn lại',
      expired: 'Hết hạn',
      extend: 'Gia hạn',
      day: 'ngày'

    },
    informationService:{
      generalInformation:'Thông tin chung',
      nameInfo:'Tên',
      organize:'Tổ chức',
      servicePack:'Gói dịch vụ',
      chargeAccordingTo:'Tính cước theo',
      month:'Tháng',
      expirationDate:'Ngày hết hạn',
      expired:'đã hết hạn',
      key:'từ khóa',
      newMonth:'tin bài mỗi tháng',
      accFolow:'tài khoản theo dõi',
      manipulation:'Thao tác',
      requestPackage:'Yêu cầu gia hạn gói dịch vụ',
      package:'Gói',
      used:'Đã sử dụng',
      upgrade:'Nâng cấp',
      keyB:'Từ khóa',
      dataMonth:'Dữ liệu/tháng',
      member:'Thành viên',
      numberDay:'Số ngày sử dụng',
      price:'Giá',
      limit:'Giới hạn',
      titlePackage:'Đã hết hạn gói dịch vụ',
      textPackage:'Bạn có muốn gia hạn ?',
      acceptText:'Xác nhận',
      cancelText:'Huỷ',
      titleRequest:'Gửi yêu cầu thành công',
      textResquest:'Yêu cầu của bạn đã được gửi tới đội ngũ chăm sóc khách hàng của Info247.\n' + 'Chúng tôi sẽ sớm xử lý và liên hệ lại với bạn. \n',
      acceptText1:'Về trang yêu cầu',
      cancelText1:'Đóng',
      titlePackage1: 'Yêu cầu đang đợi phê duyệt',
      acceptText2:'Tới trang yêu cầu',
    },
    managePackage:{
      h5:'Lịch sử & tình trạng xử lý các yêu cầu mở rộng, nâng cấp và gia hạn gói.',
      place:'Tìm kiếm...',
      userName : 'Tên tài khoản',
      namePackage: 'Tên gói',
      content:'Nội dung',
      meta:'Mô tả',
      createDay:'Ngày tạo',
      status:'Trạng thái',
      action:'Hành động',
      receive:'Tiếp nhận',
      agree:'Đồng ý',
      refuse:'Từ chối',
      cancelled:'Đã hủy',
      titleCancel:'Xác nhận hủy',
      text:'Bạn có chắc là muốn hủy yêu cầu nâng cấp',
      yes:'Có',
      can:'Hủy',
      text1:'Hủy yêu cầu nâng cấp gói thành công',
      a:'Hủy yêu cầu'
    },
    adminUser : {
      job:'Công việc/Ngành nghề',
      fullName : 'Tên đầy đủ',
      organizationName : 'Tên tổ chức',
      phoneNumber : 'Số điện thoại',
      gender : 'Giới tính',
      birthday : 'Ngày sinh',
      operationStatus : 'Trạng thái hoạt động',
      password :'Mật khẩu',
      confirmPassword : 'Xác nhận mật khẩu',
      city:'Tỉnh/Thành phố',
      district:'Quận/Huyện',
      spanNoOption:'Không có giá trị hợp lệ nào',
      subDistrict:'Xã/Phường',
      houseNumber:'Số nhà',
      address:'Địa chỉ',
      updateUser:'Cập nhật',
      createUser:'Tạo mới',
      classify : 'Phân loại',
      other : 'Khác',
      male : 'Nam',
      female : 'Nữ',
      notActivated :'Chưa kích hoạt',
      active : 'Hoạt động',
      lock : 'Bị khóa',
      back : 'Quay lại',
      more : 'Thêm ',
      accountSuccess : 'tài khoản thành công',
      deleteConfirmation : 'Xác nhận xóa',
      textDl : 'Bạn có chắc là muốn xoá tài khoản',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textSuccess : 'Xóa tổ chức thành công',

    },
    adminPackage : {
      addPackage: 'Thêm gói dịch vụ',
      search : 'Tìm kiếm ...',
      namePackage : 'Tên gói',
      totalKeyword :'Số từ khóa',
      totalSubAccount : 'Số tài khoản',
      totalData : 'Số dữ liệu',
      numberOfDays : 'Số ngày',
      price : 'Giá',
      action : 'Hành động',
      basicPackage : 'Gói cơ bản',
      allowUsersToRegister : 'Cho phép người dùng hiển thị',
      subAccountNumber : 'Số tài khoản phụ',
      displayOrder : 'Thứ tự hiển thị',
      additionalInformation : 'Thông tin bổ sung',
      confirmDelete : 'Xác nhận xóa',
      confirmCancel : 'Xác nhận hủy',
      textDelete : 'Bạn có muốn xóa gói dịch vụ ?',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textSuccess : 'Xóa chức năng giới hạn thành công',
      textAgree : 'Đồng ý',
      textRefuse : 'Từ chối',
      textUpgrade : 'Bạn có chắc là muốn hủy yêu cầu nâng cấp ',
      acceptTextUpgrade : 'Có',
      textSuccessUpgrade : 'Yêu cầu nâng cấp gói thành công',
      textRefuseUpgrade : 'Từ chối cầu nâng cấp gói thành công',
      receive : 'Tiếp nhận',
      cancelled : 'Đã hủy',
      expiredDate: 'Ngày hết hạn',
      approve: 'Duyệt',

    },
    adminFbIcon : {
      title : 'Thêm nguồn từ Facebook',
      search : 'Tìm kiếm ...',
      addFb : 'Thêm Facebook',
      formCSV : 'Mẫu CSV',
      importCSV : 'Import CSV',
      saveData : 'Lưu',
      closePopup : 'Đóng',
      path : 'Đường dẫn',
      textPath : 'Nhập đường dẫn và ấn enter...',
      nameFb : 'Tên Facebook',
      form : 'Hình thức',
      groupType : 'Loại nhóm',
      priorityLevel : 'Mức độ ưu tiên',
      statusFb : 'Trạng thái',
      gender : 'Giới tính',
      address : 'Địa chỉ ',
      create : 'Tạo mới',
      back : 'Quay lại',
      female : 'Nữ',
      male : 'Nam',
      normal : 'Bình thường',
      prioritize : 'Ưu tiên',
      specialPriority : 'Ưu tiên đặc biệt',
      active : 'Hoạt động',
      inactive : 'Không hoạt động',
      profilePage : 'Trang cá nhân',
      pageFb : 'Trang Facebook',
      groupFb : 'Nhóm Facebook',
      alone : 'Độc thân',
      married : 'Đã kết hôn',
      other : 'Khác',
      privateGroup : 'Nhóm kín',
      publicGroup : 'Công khai',
      type : 'Loại',
      action : 'Hành động',
      text : 'Không tìm thấy thông tin',
      update : 'Cập nhật',
      add : 'Thêm',
      text2 : 'thông tin facebook thành công',
      text3 : 'Loại không hợp lệ',
      text4 : 'Thêm mới thành công',
      notActive : 'Chưa kích hoạt',
      lock : 'Bị khóa',
      titleDelete : 'Xác nhận xóa',
      textDelete : 'Bạn có chắc là muốn xoá thông tin tài khoản facebook:',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textSuccess : 'Xóa thông tin nguồn Facebook thành công',
    },
    adminWs : {
      title : 'Thêm nguồn từ Website',
      addWs : 'Thêm mới Website',
      formCSV : 'Mẫu CSV',
      importCSV : 'Import CSV',
      status : 'Trạng thái',
      search : 'Tìm kiếm ...',
      save : 'Lưu',
      closed : 'Đóng',
      update : 'Cập nhật',
      create : 'Tạo mới',
      back : 'Quay lại',
      all : 'Tất cả',
      received : 'Đã tiếp nhận yêu cầu',
      processed : 'Đang phân tích yêu cầu',
      ready : 'Đang thu thập dữ liệu',
      scanning : 'Đang thu thập dữ liệu',
      newspapers : 'Báo chí',
      news : 'Tin tức',
      other : 'Khác',
      nameWs : 'Tên Website',
      group : 'Nhóm',
      action : 'Hành động',
      textIllegal : 'Loại website không hợp lệ',
      textIllegalFb : 'Loại facebook không hợp lệ',
      textSuccess : 'Thêm mới thành công',
      titleDelete : 'Xác nhận xóa',
      textDelete : 'Bạn có chắc là muốn xóa thông tin website :',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textDeleteSuccess : 'Xóa thông tin website thành công',
      textManipulation : 'Thao tác thành công',
      path : 'Đường dẫn',
      catalogCode : 'Mã danh mục',
      type : 'Loại Website',
      address : 'Địa chỉ Website',
      configuration : 'Cấu hình',
      active : 'Hoạt động',
      inactive : 'Không hoạt động',
      textFooter : 'Website thành công',
      addFindSource: 'Thêm nguồn tìm kiếm thành công',
      cancelFindSource: 'Huỷ thêm nguồn tìm kiếm thành công'
    },
    adminUserICon : {
      title : 'Thêm tài khoản',
      search : 'Tìm kiếm ...',
      account : 'Tài khoản',
      pass : 'Mật khẩu',
      creatorCode : 'Mã người tạo',
      creator : 'Người tạo',
      dateCreated : 'Ngày tạo',
      accountStatus : 'Trạng thái tài khoản',
      effect : 'Hiệu lực',
      action : 'Hành động',
      type : 'Loại tài khoản',
      normal : 'Bình thường',
      prioritize : 'Ưu tiên',
      notUsedYet : 'Chưa được sử dụng',
      wasUsed : 'Đã được sử dụng',
      effective : 'Có hiệu lực',
      notEffective : 'Không hiệu lực',
      update : 'Cập nhật',
      create : 'Tạo mới',
      back : 'Quay lại',
      other : 'Khác',
      titleDelete : 'Xác nhận xóa',
      textDelete : 'Bạn có chắc là muốn xoá thông tin tài khoản:',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textSuccess : 'Xóa thông tin tài khoản thành công'
    },
    realtimeChart : {
      boxTime : 'Khoảng thời gian',
      placeTime : 'Chọn khoảng thời gian',
      boxData : 'Làm mới dữ liệu',
      placeTimeData : 'Chọn khoảng thời gian làm mới dữ liệu',
      titleData : 'Dữ liệu hiện tại :',
      data : 'Dữ liệu',
      text1p : '1 phút trước',
      text5p : '5 phút ',
      text10p : '10 phút ',
      text30p : '30 phút',
      text1t : '1 tiếng',
      text4t : '4 tiếng',
      text12t : '12 tiếng',
      text1day : '1 ngày',
      startDate : 'Thời gian bắt đầu',

    },
    permission : {
      title : 'Thêm chức năng',
      search : 'Tìm kiếm ...',
      nameFunction : 'Tên chức năng',
      action : 'Hành động',
      displayName : 'Tên hiển thị',
      additionalInformation : 'Thông tin bổ sung',
      update : 'Cập nhật',
      create : 'Tạo mới',
      back : 'Quay lại',
      titleDelete : 'Xác nhận xóa',
      textDelete : 'Bạn có chắc là muốn xoá chức năng giới hạn ',
      acceptText : 'Xóa',
      cancelText : 'Hủy',
      textSuccess : 'Xoá chức năng giới hạn thành công',
      add : 'Thêm',
      textUpdate : 'chức năng giới hạn thành công',
      textDelete2 : 'Bạn có chắc là muốn xoá',
    },
    projectAndTopic : {
      noteFavourite : 'Chưa có dự án yêu thích',
      inputSourceInvalid: 'Nguồn không hợp lệ: ',
      estimate : 'Ước tính dữ  liệu',
      preview : 'Xem trước',
      sourceInvalid: 'Chưa chọn nguồn dữ liệu',
      topicGroupAlreadyExist: 'Nhóm chủ đề đã tồn tại',
      endDateInvalid: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
      isActive : 'Hoạt động',
      continue : 'Tiếp tục',
      pause :'Tạm dừng',
      favourite : 'Yêu thích',
      projects : 'Các dự án ',
      updateProject: 'Cấu hình chủ đề',
      createNewProject : 'Tạo dự án mới',
      createNewTopic : 'Tạo chủ đề mới',
      all : 'Tất cả',
      otherTopics : 'Các chủ đề khác',
      topicC : 'CHỦ ĐỀ',
      createNewTopicC : 'TẠO CHỦ ĐỀ MỚI',
      status : 'Tình trạng',
      info : 'THÔNG TIN',
      description : 'Mô tả',
      creator : 'Người tạo',
      createDate : 'Ngày tạo',
      viewStatistical : 'Xem thống kê',
      viewNews : 'Xem tin bài',
      editProject : 'Cấu hình dự án',
      projectFavourite : 'Đánh dấu yêu thích',
      removeFavoriteGroupTopic: 'Bỏ yêu thích',
      deleteProject : 'Xóa dự án',
      keyword : 'TỪ KHÓA',
      createBy : 'Chia sẻ bởi',
      crawl : 'thu thập dữ liệu chủ đề : ',
      editTopic : 'Cấu hình chủ đề',
      copyTopic : 'Sao chép chủ đề',
      tickFavouriteTopic : 'Đánh dấu chủ đề yêu thích',
      deleteTopic : 'Xóa chủ đề',
      cancelText : 'Hủy',
      update : 'Cập nhật',
      accept : 'Xác nhận',
      textFavourite : 'yêu thích thành công',
      textSuccessDelete : 'Xóa thành công dự án',
      textSuccessDelete2 : 'Xóa thành công chủ đề ',
      titleDelete : 'Xác nhận xóa dự án',
      textDelete : 'Bạn có chắc là muốn xóa dự án ',
      titleDelete2 : 'Xác nhận xóa chủ đề',
      textDelete2 : 'Bạn có chắc là muốn xóa chủ đề',
      deleted : 'Đã xóa',
      textSuccessCopy : 'Sao chép thành công chủ đề',
      textKeyword : 'Từ khóa chính không được để trống',
      textKeyword2 : 'Từ khóa chính không được trùng với từ khóa loại trừ.',
      textTheme2 : 'Chủ đề không được để trống',
      add : 'Tạo mới',
      textAdd : 'thành công chủ đề',
      addProject : 'Tạo dự án mới',
      nameProject : 'Đặt tên dự án',
      desNameProject : 'Tên dự án có thể là : Tên của một thương\n' +
        '              hiệu, một sản\n' +
        '              phẩm/dịch vụ, tên của một chiến dịch',
      desProject : 'Mô tả dự án',
      desToDes : 'Mô tả dự án giúp bạn xác định rõ mục tiêu\n' +
        '              của mỗi dự án,\n' +
        '              phân biệt với các dự án khác trong danh mục',
      colorProject : 'Chọn màu dự án',
      desColor : 'Sử dụng màu sắc hoặc biểu tượng giúp bạn dễ\n' +
        '              dàng nhận diện và phân biệt các dự án trong quá trình quản lý.',
      timeFollow : 'Khoảng thời gian muốn theo dõi',
      startDate : 'Ngày bắt đầu :',
      desStartDate : 'Các dữ liệu được thu thập bắt đầu từ ngày\n' +
        '                này',
      selectTime : 'Chọn ngày bắt đầu',
      endDate : 'Ngày kết thúc : ',
      desEndDate : 'Ngày kết thúc quá trình thu thập dữ\n' +
        '                liệu.',
      selectTime2 : 'Chọn ngày kết thúc',
      addTopicFirst : 'Tạo chủ đề đầu tiên',
      savaProject : 'Lưu dự án ',
      textCampaign : 'Tên Dự án không được để trống',
      textCampaign2 : 'Tên Dự Án tối đa 100 kí tự',
      textSuccess : 'thành công dự án',
      configurationTopic : 'Cấu hình chủ đề',
      addTopic : 'Tạo chủ đề',
      nameTopic : 'Tên chủ đề :',
      availableProjects : 'Thêm vào một dự án đã có',
      project : 'Dự án : ',
      chooseProject : 'Chọn dự án',
      mainKey : 'Từ khóa chính',
      desMainKey : 'Từ khóa tên thương hiệu, sản phẩm dịch vụ,\n' +
        '                tên chiến dịch\n' +
        '                hoặc vấn đề cần theo dõi',
      subKey : 'Từ khóa phụ',
      desSubKey : 'Các từ khóa mô tả cụ thể, chi tiết và rõ\n' +
        '                ràng hơn về thương\n' +
        '                hiệu, sản phẩm, chiến dịch nhằm tối ưu lượng tin bài.',
      removeKey : 'Từ khóa loại bỏ',
      desRemoveKey : 'Những tin bài có chứa\n' +
        '                các từ khóa spam, rác này sẽ không\n' +
        '                được thu thập.',
      placeMainKey : 'Tên thương hiệu, Sản phẩm,  ....',
      keyword1 : 'Từ khóa',
      placeSubKey : 'Đặc điểm thuộc tính của từ khóa phụ',
      placeRemoveKey : 'Từ khóa loại bỏ ...',
      addKeyword : 'Thêm từ khóa',
      source : 'Nguồn',
      selectedSource: 'Dữ liệu tin bài của chủ đề được thu thập từ',
      textSource : 'Nhập thêm nguồn dữ liệu bạn muốn yêu cầu theo dõi đặc biệt',
      allSource : 'Tất cả các nguồn',
      newsPapers : 'Báo chí',
      forum : 'Diễn đàn',
      specialSource : 'Nguồn đặc biệt',
      addSource : 'Thêm nguồn đặc biệt mới',
      saveTopic : 'Lưu chủ đề',
      textLength : 'Độ dài vượt quá 20 ký tự',
      textTheme3 : 'Chủ đề có ít nhất 1 từ khóa',
      textTheme4: 'Có ít nhất 1 trường nhập nguồn',
      addNewKeyword : 'Tạo từ khóa mới',
      saveKey : 'Tạo từ khóa',
      deleteKey : 'Xóa từ khóa',
      saveProject:'Lưu dự án',
      addToAnExistingProject: 'Thêm vào một dự án đã có',
      sharedBy: 'Chia sẻ bởi',
      createNewKeyword: 'Thêm mới từ khoá'
    },

    popupConfirm:{
      titlePopup:'Bạn chắc chắn muốn xóa?',
      titlePopupTrial:'Bạn có muốn dùng thử ?',
      subtitle:'Bạn không thể khôi phục hành động này',
      accept:'Đồng ý xóa',
      accept1:'Đồng ý xóa',
      accept2:'Đồng ý',
      close:'Đóng'
    },
    rules:{
      textThanks:'Cảm ơn bạn đã quan tâm và truy cập Info247. Chúng tôi tôn trọng và cam kết sẽ bảo mật thông tin mang tính riêng tư của bạn. Xin vui lòng đọc bản Điều khoản sử dụng của Info247 dưới đây để hiểu hơn những cam kết mà chúng tôi thực hiện nhằm tôn trọng và bảo vệ quyền lợi của người truy cập.',
      textConfirm:'Chấp nhận các điều khoản',
      textSubConfirm:'Info247 cung cấp Dịch vụ của mình (như được định nghĩa bên dưới) cho Bạn thông qua trang web của mình tại Info247.vn (“Trang web”), tùy thuộc vào Điều kiện. Bằng cách chấp nhận Điều khoản hoặc bằng cách truy cập hoặc sử dụng Dịch vụ hoặc Trang web, Bạn tuyên bố và thừa nhận rằng Bạn đã đọc, hiểu và đồng ý bị ràng buộc bởi các Điều khoản này và thông tin bạn cung cấp khi đăng ký Dịch vụ là chính xác, đầy đủ , và là của bạn hoặc trong quyền sử dụng của bạn. Nếu bạn đang thay mặt một công ty hoặc một pháp nhân khác, Bạn đại diện cho rằng Bạn có quyền ràng buộc thực thể đó và các chi nhánh của nó đối với các Điều khoản này, trong trường hợp này, các thuật ngữ “Bạn”, “của Bạn” hoặc có liên quan được viết hoa các điều khoản ở đây sẽ đề cập đến thực thể đó và các chi nhánh của nó. Nếu Bạn không có thẩm quyền như vậy, hoặc nếu Bạn không đồng ý với các Điều khoản này, Bạn không được chấp nhận các Điều khoản này và không được sử dụng Dịch vụ. Bạn thừa nhận rằng các Điều khoản này cấu thành một hợp đồng giữa Bạn và Info247, mặc dù đây là bản thỏa thuận điện tử và không có chữ ký thực tế của Bạn và Info247. Bạn cũng thừa nhận rằng các Điều khoản này chi phối việc sử dụng Dịch vụ của bạn, ngoại trừ các phụ lục bằng văn bản có chữ ký của các bên sửa đổi cụ thể các Điều khoản này, các Điều khoản này sẽ thay thế mọi thỏa thuận khác giữa Bạn và Info247.',
      textPossibility:'Tính khả dụng của trang web',
      textSubPossibility:'Bạn thừa nhận rằng có thể có sự gián đoạn trong dịch vụ hoặc sự kiện nằm ngoài tầm kiểm soát của chúng tôi. Mặc dù chúng tôi sử dụng các nỗ lực cao nhất để giữ cho Trang web có thể truy cập được, Trang web đôi khi không có sẵn vì bất kỳ lý do nào, bao gồm, không giới hạn, bảo trì định kỳ. Bạn hiểu và thừa nhận rằng do hoàn cảnh cả trong và ngoài tầm kiểm soát của chúng tôi, quyền truy cập trang web có thể bị gián đoạn, tạm ngưng hoặc chấm dứt. Bạn hiểu thêm rằng có thể có sự gián đoạn dịch vụ hoặc sự kiện trên trang web của bên thứ ba, bao gồm, nhưng không giới hạn, Facebook, Youtube, v.v … sẽ ảnh hưởng đến việc bạn sử dụng Dịch vụ (được định nghĩa bên dưới) và việc sửa chữa là ngoài tầm kiểm soát của chúng tôi. Việc gián đoạn Dịch vụ nằm ngoài tầm kiểm soát của chúng tôi sẽ không làm cơ sở để chấm dứt đăng ký của bạn hoặc yêu cầu hoàn lại toàn bộ hoặc một phần bất kỳ khoản phí trả trước nào.',
      textService:'Mô tả dịch vụ',
      textSubService:'“Dịch vụ” bao gồm (a) Trang web, (b) Ứng dụng di động Info247 và (c) các dịch vụ khác được cung cấp cho Bạn thông qua Trang web dựa trên kế hoạch đã mua, bao gồm tất cả phần mềm, dữ liệu, văn bản, hình ảnh, âm thanh, video và nội dung khác được cung cấp qua Trang web (gọi chung là “Nội dung”). Mọi tính năng mới được thêm vào hoặc tăng cường Dịch vụ cũng phải tuân theo các Điều khoản này. Một số tính năng mới nhất định thường được cung cấp miễn phí cho tất cả khách hàng đăng ký sẽ được cung cấp miễn phí cho bạn. Tuy nhiên, tính khả dụng của một số tính năng mới có thể yêu cầu thanh toán các khoản phí bổ sung và Info247 sẽ tự quyết định xem có quyền truy cập vào bất kỳ tính năng mới nào khác như vậy hay không sẽ yêu cầu một khoản phí bổ sung. Dịch vụ cũng có thể bao gồm các dịch vụ cơ bản hoặc mở rộng dựa trên gói dịch vụ đã mua. Info247 sẽ sử dụng các nỗ lực hợp lý về mặt thương mại để cung cấp Dịch vụ có sẵn trong kế hoạch Dịch vụ hiện hành, ngoại trừ: (a) thời gian ngừng hoạt động dự kiến hoặc (b) bất kỳ tình trạng không có sẵn nào do các trường hợp ngoài tầm kiểm soát hợp lý của chúng tôi. để, hành động của các tôn giáo, hoạt động của chính phủ, hành vi khủng bố hoặc bất ổn dân sự, hoặc thất bại kỹ thuật ngoài tầm kiểm soát của chúng tôi.',
      textAppPhone:'Ứng dụng di động',
      textSubAppPhone:'Info247 cung cấp ứng dụng dành cho thiết bị di động truy cập Dịch vụ qua thiết bị di động. Để sử dụng Ứng dụng di động Bạn phải có một thiết bị di động tương thích với dịch vụ di động. Chúng tôi không đảm bảo rằng Ứng dụng dành cho thiết bị di động sẽ tương thích với thiết bị di động của bạn. Info247 cấp cho Bạn giấy phép không độc quyền, không thể chuyển nhượng, có thể hủy bỏ để sử dụng bản sao mã đối tượng của Ứng dụng dành cho thiết bị di động cho một tài khoản đã đăng ký trên một thiết bị di động do bạn sở hữu hoặc cho thuê. Bạn không được: (i) sửa đổi, gỡ bỏ, dịch ngược hoặc đảo ngược thiết kế ứng dụng di động; (ii) thuê, cho thuê, bán lại, cấp phép lại, phân phối hoặc chuyển giao Ứng dụng di động cho bất kỳ bên thứ ba nào hoặc sử dụng Ứng dụng dành cho thiết bị di động để chia sẻ thời gian hoặc các dịch vụ tương tự cho bất kỳ bên thứ ba nào; (iii) tạo bất kỳ bản sao nào của Ứng dụng Di động; (iv) xóa, phá vỡ, vô hiệu hóa, làm hỏng hoặc can thiệp vào các tính năng liên quan đến bảo mật của Ứng dụng di động, các tính năng ngăn chặn hoặc hạn chế sử dụng hoặc sao chép bất kỳ nội dung nào có thể truy cập được qua Ứng dụng di động hoặc các tính năng Ứng dụng; hoặc (v) xóa thông báo bản quyền và các quyền sở hữu khác trên Ứng dụng di động. Bạn thừa nhận rằng thỉnh thoảng chúng tôi có thể phát hành phiên bản nâng cấp của Ứng dụng dành cho thiết bị di động và có thể tự động nâng cấp phiên bản ứng dụng di động mà bạn đang sử dụng trên thiết bị di động của bạn. Bạn đồng ý với việc nâng cấp tự động như vậy trên thiết bị di động của mình và đồng ý rằng các Điều khoản này sẽ áp dụng cho tất cả các nâng cấp như vậy. Việc cấp giấy phép nói trên không phải là việc bán Ứng dụng dành cho thiết bị di động hoặc bất kỳ bản sao nào, và Info247 và nhà cấp phép hoặc nhà cung cấp bên thứ ba giữ lại tất cả quyền, danh hiệu và lợi ích trong và cho Ứng dụng dành cho thiết bị di động (và bất kỳ bản sao Di động nào Ứng dụng). Phí dữ liệu của nhà cung cấp dịch vụ tiêu chuẩn có thể áp dụng cho việc bạn sử dụng Ứng dụng dành cho thiết bị di động. Các điều khoản và điều kiện bổ sung sau áp dụng cho bất kỳ Ứng dụng di động nào mà Info247 cung cấp cho bạn được thiết kế để sử dụng trên thiết bị di động được Apple iOS hỗ trợ (“Ứng dụng iOS”): Bạn thừa nhận rằng các Điều khoản này chỉ nằm giữa Bạn và Info247 chứ không phải với Apple, Inc. (“Apple”). Việc bạn sử dụng Ứng dụng iOS phải tuân thủ Điều khoản dịch vụ của App Store hiện tại của Apple. Info247, chứ không phải Apple, chịu trách nhiệm hoàn toàn về Ứng dụng iOS và các dịch vụ và nội dung có sẵn trên đó. Bạn thừa nhận rằng Apple không có nghĩa vụ cung cấp dịch vụ bảo trì và hỗ trợ liên quan đến Ứng dụng iOS của chúng tôi. Trong phạm vi tối đa được luật hiện hành cho phép, Apple sẽ không có nghĩa vụ bảo hành đối với Ứng dụng iOS. Bạn đồng ý rằng Info247 chứ không phải Apple, chịu trách nhiệm giải quyết mọi khiếu nại của Bạn hoặc bất kỳ bên thứ ba nào liên quan đến Ứng dụng iOS hoặc việc bạn sở hữu và / hoặc sử dụng Ứng dụng iOS, bao gồm, nhưng không giới hạn: (i ) tuyên bố trách nhiệm sản phẩm; (ii) mọi tuyên bố rằng Ứng dụng iOS không tuân thủ bất kỳ yêu cầu pháp lý hoặc quy định hiện hành nào; và (iii) các khiếu nại phát sinh để bảo vệ người tiêu dùng hoặc pháp luật tương tự và tất cả các khiếu nại đó chỉ được điều chỉnh bởi các Điều khoản này và mọi luật áp dụng cho chúng tôi với tư cách là nhà cung cấp Ứng dụng iOS. Bạn đồng ý rằng Info247, chứ không phải Apple, sẽ chịu trách nhiệm, trong phạm vi được các Điều khoản này yêu cầu, để điều tra, bảo vệ, giải quyết và dỡ bỏ bất kỳ khiếu nại vi phạm quyền sở hữu trí tuệ của bên thứ ba nào liên quan đến Ứng dụng iOS hoặc quyền sở hữu của bạn và sử dụng Ứng dụng iOS. Bạn tuyên bố và đảm bảo rằng (i) Bạn không sống ở một quốc gia chịu sự cấm vận của Chính phủ Việt Nam hoặc đã được Chính phủ Việt Nam chỉ định là quốc gia “hỗ trợ khủng bố”; và (ii) Bạn không được liệt kê trong danh sách các bên bị cấm hoặc bị hạn chế của Chính phủ Việt Nam. Bạn đồng ý tuân thủ tất cả các điều khoản thỏa thuận của bên thứ ba hiện hành khi sử dụng Ứng dụng iOS (ví dụ: bạn không được vi phạm điều khoản dịch vụ dữ liệu không dây của mình khi sử dụng Ứng dụng iOS). Bạn đồng ý rằng các công ty con của Apple và Apple là bên hưởng lợi thứ ba đối với các Điều khoản này vì chúng có liên quan đến giấy phép của bạn về Ứng dụng iOS. Khi bạn chấp nhận các Điều khoản này, Apple sẽ có quyền (và sẽ được coi là đã chấp nhận quyền) để thực thi các Điều khoản này chống lại Bạn vì chúng liên quan đến Giấy phép của bạn về Ứng dụng iOS với tư cách là người thụ hưởng bên thứ ba. Các điều khoản và điều kiện bổ sung sau áp dụng cho bất kỳ Ứng dụng di động nào mà Info247™ cung cấp cho bạn được thiết kế để sử dụng trên thiết bị di động được Android hỗ trợ (“Ứng dụng Android”): Bạn thừa nhận rằng các Điều khoản này nằm giữa bạn và chỉ Info247 chứ không phải với Google, Inc. (“Google”). Việc bạn sử dụng Ứng dụng Android phải tuân thủ Điều khoản dịch vụ của Android Market hiện tại của Google. Google chỉ là nhà cung cấp của Android Market nơi bạn có được Ứng dụng Android.',
      textPay:'Thanh toán, sửa đổi gói và thanh toán',
      textSubPay:'Lập hóa đơn và thanh toán. Nếu không có thoả thuận khác bằng văn bản của Info247, dịch vụ sẽ được cung cấp ngay khi bạn thanh toán và được tính vào lúc bắt đầu Thời hạn đăng ký (thường là hàng tháng hoặc hàng năm). Nếu bạn không cung cấp thông tin gia hạn thanh toán khác cho Info247 trước khi hết thời gian dùng thử miễn phí, tài khoản của bạn sẽ bị tạm ngưng cho đến khi thông tin thanh toán tính phí được cung cấp. Sửa đổi đăng ký của bạn. Nếu bạn chọn nâng cấp gói hoặc số lượng người dùng của bạn trong thời gian đăng ký của bạn, mọi chi phí gia tăng sẽ được tính theo tỷ lệ phần còn lại của thời hạn đăng ký và được tính vào tài khoản của bạn. Bạn sẽ bị tính phí điều chỉnh trên các chu kỳ thanh toán tiếp theo. Hạ cấp tài khoản của bạn có thể làm mất nội dung, tính năng hoặc khả năng tài khoản của bạn và Info247 không chấp nhận bất kỳ trách nhiệm pháp lý nào đối với việc mất mát đó. Phí quá hạn. Nếu bạn không thanh toán phí đăng ký đúng và bạn không thông báo cho chúng tôi về kế hoạch thanh toán của bạn, toàn bộ đăng ký của bạn có thể bị tạm ngưng hoặc hủy. Ngay cả sau khi đăng ký của bạn bị tạm ngưng hoặc bị hủy, bạn vẫn có thể liên hệ với chúng tôi để khôi phục quyền truy cập vào Dịch vụ bằng cách cung cấp nguồn thanh toán phù hợp. Sau khi đăng ký của bạn bị chấm dứt, chúng tôi sẽ lưu giữ các cài đặt tài khoản hiện tại của bạn trong 90 ngày. Sau thời gian đó, Info247 bảo lưu quyền xóa các cài đặt đó khỏi máy chủ của chúng tôi mà KHÔNG có trách nhiệm hoặc thông báo cho bạn.',
      textWisdom:'Quyền sở hữu trí tuệ',
      textSubWisdom:'A. Các tên sản phẩm và dịch vụ khác của Info247 và các sản phẩm khác được sử dụng hoặc hiển thị trên Dịch vụ là các thương hiệu đã đăng ký hoặc chưa đăng ký của Info247, và bạn chỉ có thể sử dụng các nhãn hiệu đó để xác định chính mình là khách hàng và người dùng Dịch vụ. Hiện tại và trong tương lai, bạn sẽ không được phép lấy nhãn hiệu hoặc làm suy giảm tính khác biệt của nhãn hiệu, hoặc sử dụng nhãn hiệu để làm xáo trộn hoặc xuyên Info247, dịch vụ hoặc sản phẩm của nó. B. Tất cả các quyền, quyền và lợi ích trong và đối với Dịch vụ và các thành phần của nó, bao gồm tất cả các quyền sở hữu trí tuệ liên quan, sẽ vẫn thuộc và độc quyền cho Info247. C. Quy trình báo cáo vi phạm bản quyền. Nếu Người Sử Dụng tin rằng bất kỳ nội dung, tài liệu, hình ảnh, video hoặc các tài liệu khác của mình được cung cấp thông qua Dịch vụ Info247 đang bị vi phạm quyền sở hữu trí tuệ, vui lòng thông báo cho chúng tôi về việc vi phạm bản quyền theo quy trình cụ thể được quy định dưới đây: (1) Chúng tôi sẽ xử lý từng thông báo vi phạm bản quyền mà chúng tôi nhận được và xử lý theo quy định của pháp luật sở hữu trí tuệ; (2) Để giúp chúng tôi có đủ cơ sở đáp ứng các yêu cầu của bạn, vui lòng gửi thông báo bằng văn bản với các thông tin sau; (a) Chữ ký thật của người người được ủy quyền thay mặt cho chủ sở hữu của một sản phẩm độc quyền; (b)Mô tả tác phẩm có bản quyền mà bạn cho là bị vi phạm; (c) Mô tả về nơi mà các tài liệu bạn cho là vi phạm nằm trên các Dịch vụ Info247 đủ để cho phép Info247 xác định vị trí tài liệu đó; (d) Thông tin liên hệ của bạn như địa chỉ, số điện thoại, email để Info247 có thể liên hệ với bạn; (e) Bạn tuyên bố rằng bạn tin tưởng việc sử dụng nội dung đó là không được phép của chủ sở hữu quyền tác giả, đại lý độc quyền hoặc pháp luật; (f) Bạn tuyên bố rằng các thông tin trong thông báo của bạn là chính xác và bạn chấp nhận hình phạt về tội khai man mà bạn được ủy quyền hành động thay mặt cho chủ sở hữu bản quyền. Nếu tài khoản Info247 vi phạm về sở hữu trí tuệ thông qua việc Người Sử Dụng gửi thông báo, nếu kết quả cho thấy Tài khoản có sự vi phạm thì tùy vào mức độ nghiêm trọng của sự việc, Info247 có toàn quyền quyết định xóa tài khoản vi phạm đó.',
      textSignUp:'Đăng ký tài khoản',
      textSubSingUp:'A. Theo các điều khoản và điều kiện của các Điều khoản này, Bạn đồng ý chỉ truy cập và sử dụng Dịch vụ cho mục đích kinh doanh nội bộ của bạn như được nêu ra bởi các Điều khoản này. Để sử dụng Dịch vụ, bạn phải đăng ký dịch vụ của chúng tôi và bạn sẽ phải trả phí đăng ký để sử dụng Dịch vụ sau khi hết hạn hoặc chấm dứt bất kỳ tài khoản dùng thử miễn phí nào. Phí đăng ký, sau khi hết hạn hoặc chấm dứt bất kỳ tài khoản dùng thử miễn phí nào, phải được trả trước để sử dụng Dịch vụ. B. Nếu Bạn thêm Người dùng vào tài khoản của mình, bạn sẽ hoàn toàn chịu trách nhiệm về mọi vi phạm Điều khoản này bởi Người dùng của bạn. Bằng cách thêm bất kỳ Người dùng nào vào tài khoản của bạn, Bạn đảm bảo rằng: (i) Bạn đã nhận được tất cả các ủy quyền cần thiết, sự đồng ý của Người dùng đó để tuân theo Thỏa thuận này. Bạn luôn phải chịu trách nhiệm hoàn toàn và chịu trách nhiệm về mọi hành động và thiếu sót của Người dùng của bạn và Bạn đồng ý bồi thường cho Info247 cho tất cả các khiếu nại và tổn thất liên quan đến bất kỳ hành động và / hoặc thiếu sót nào. C. Để đủ điều kiện sử dụng Dịch vụ, bạn phải đáp ứng các tiêu chí sau đây và tuyên bố và đảm bảo rằng bạn: (1) từ 18 tuổi trở lên; (2) hiện không bị hạn chế bởi Dịch vụ, hoặc không bị cấm có tài khoản Info247.vn, (3) không phải là đối thủ cạnh tranh của Info247 hoặc không sử dụng Dịch vụ vì các lý do cạnh tranh với Info247 ; (4) có đầy đủ quyền hạn và thẩm quyền để tham gia vào Thỏa thuận này và làm như vậy sẽ không vi phạm bất kỳ thỏa thuận nào khác mà bạn đang có liên quan; (5) sẽ không vi phạm bất kỳ quyền nào của Info247, bao gồm các quyền sở hữu trí tuệ như quyền tác giả hoặc nhãn hiệu; và (6) đồng ý cung cấp chi phí của bạn tất cả các thiết bị, phần mềm và truy cập internet cần thiết để sử dụng Dịch vụ.',
      textUseService:'Sử dụng dịch vụ',
      textSubUseService:'A. Bạn không được phép và không cho phép, khuyến khích hoặc khuyến khích bất kỳ bên thứ ba nào (bao gồm bất kỳ Người dùng nào) (a) giấy phép, cấp phép phụ, bán, bán lại, cho thuê, cho thuê, chuyển nhượng, phân phối Info247 cho người dùng nào khác, (b) sử dụng Dịch vụ để xử lý dữ liệu thay mặt cho bất kỳ bên thứ ba nào, (c) sửa đổi, điều chỉnh hoặc tấn công Dịch hoặc cố gắng truy cập trái phép Dịch vụ; (d) sử dụng Dịch vụ theo bất kỳ cách nào trái pháp luật, vi phạm quyền riêng tư của mọi người, vi phạm quyền sở hữu trí tuệ của bất kỳ ai hoặc gửi spam hoặc các thông điệp trùng lặp hoặc không được yêu cầu vi phạm pháp luật hiện hành, (e) sử dụng Dịch vụ theo bất kỳ cách nào cản trở hoặc phá vỡ tính toàn vẹn hoặc hiệu suất của Dịch vụ và các thành phần của Dịch vụ; (f) cố gắng giải mã, dịch ngược, đảo ngược kỹ thuật hoặc phát hiện ra mã nguồn của bất kỳ phần mềm nào tạo nên Dịch vụ; (g) sử dụng Dịch vụ để cố ý đăng, tải lên, liên kết, gửi hoặc lưu trữ bất kỳ nội dung bất hợp pháp, phân biệt chủng tộc, thù hận, khiêu dâm, phân biệt đối xử hoặc chứa bất kỳ vi-rút, phần mềm độc hại, bom thời gian hoặc bất kỳ tác hại tương tự nào khác phần mềm; (h) cố gắng sử dụng bất kỳ phương pháp nào để truy cập trái phép vào bất kỳ tính năng trả phí nào của Trang web; (i) sử dụng tập lệnh tự động để thu thập thông tin từ hoặc tương tác với Trang web hoặc Dịch vụ; (j) liên kết sâu đến Trang web cho bất kỳ mục đích nào (trừ trang chủ của Info247), trừ khi được uỷ quyền rõ ràng bằng văn bản của Info247; (k) mạo danh bất kỳ người dùng nào khác của Dịch vụ; hoặc (m) cố gắng sử dụng hoặc sử dụng Dịch vụ vi phạm các Điều khoản này. B. Bạn chịu trách nhiệm về tất cả thông tin, dữ liệu, văn bản, tin nhắn hoặc các tài liệu khác mà Bạn hoặc Người dùng của bạn đăng hoặc truyền tải thông qua Dịch vụ. Bạn chịu trách nhiệm duy trì tính bảo mật của thông tin đăng nhập và tài khoản của bạn và hoàn toàn chịu trách nhiệm về bất kỳ và tất cả các hoạt động xảy ra dưới hoặc liên quan đến thông tin đăng nhập hoặc tài khoản của bạn. Bạn đồng ý và thừa nhận rằng Đăng nhập của bạn chỉ có thể được sử dụng bởi một người và bạn sẽ không chia sẻ một lần đăng nhập duy nhất giữa nhiều người. Bạn đồng ý rằng Bạn sẽ không bán, trao đổi hoặc chuyển giao thông tin đăng nhập hoặc tài khoản của bạn cho một bên khác, trừ khi có sự đồng ý cụ thể bằng văn bản của Info247. Bạn đồng ý rằng bạn chịu trách nhiệm về bất kỳ điều gì xảy ra thông qua tài khoản của bạn, bao gồm các hành vi hoặc thiếu sót của Người dùng của bạn.',
      textSecurity:'Bảo mật dữ liệu và bảo mật',
      textSubSecurity:'A. Khi cung cấp cho Bạn Dịch vụ, Chúng tôi sẽ duy trì các biện pháp bảo vệ thích hợp để bảo vệ tính bảo mật, bảo mật và tính toàn vẹn của dữ liệu của bạn và dữ liệu cá nhân của người dùng cuối của bạn. Chúng tôi đồng ý thông báo ngay cho bạn trong trường hợp Info247 biết hoặc có lý do để tin rằng bất kỳ cá nhân hoặc tổ chức nào đã vi phạm các biện pháp của Info247 hoặc giành quyền truy cập trái phép vào dữ liệu của bạn (“Vi phạm an ninh thông tin”). Khi có bất kỳ phát hiện nào như vậy, chúng tôi sẽ: (a) điều tra và giảm thiểu ảnh hưởng của Vi phạm An ninh Thông tin, (b) sử dụng những nỗ lực tốt nhất của chúng tôi để đảm bảo rằng việc đó sẽ không tái diễn, và (c) hỗ trợ Bạn khắc phục việc này. Chúng tôi sẽ sử dụng các nỗ lực hợp lý về mặt thương mại để kịp thời xử lý kịp thời các yêu cầu và yêu cầu của Bạn liên quan đến việc xử lý dữ liệu của bạn. B. Bạn đồng ý rằng Info247 có thể truy cập thông tin tài khoản của bạn để đáp ứng các yêu cầu dịch vụ của bạn. Chúng tôi sẽ không tiết lộ dữ liệu đó trừ khi bị pháp luật bắt buộc, được bạn cho phép hoặc theo các điều khoản của Chính sách bảo mật Info247 có sẵn tại Info247.vn và được đưa vào các Điều khoản này. Chúng tôi đồng ý lưu trữ, sử dụng và xử lý thông tin liên hệ của doanh nghiệp của bạn, bao gồm tên, số điện thoại doanh nghiệp và địa chỉ email doanh nghiệp chỉ trong phạm vi cần thiết để cung cấp cho bạn Dịch vụ. Chúng tôi sẽ không tiết lộ thông tin liên hệ kinh doanh đó cho bên thứ ba trừ khi được bạn cho phép bằng văn bản. C. Chính sách bảo mật quyết định việc chúng tôi xử lý bất kỳ thông tin nào, bao gồm thông tin nhận dạng cá nhân, bạn gửi cho chúng tôi. Bạn xác nhận rằng việc bạn gửi bất kỳ thông tin, tuyên bố, dữ liệu và nội dung nào cho chúng tôi là tự nguyện.',
      textCancellation:'Hủy bỏ và chấm dứt',
      textSubCancellation:'A. Bạn có thể hủy tài khoản của mình trên Info247 bất kỳ lúc nào; tuy nhiên, bạn sẽ không được hoàn lại tiền, trừ khi Info247 vi phạm Thỏa thuận này và không khắc phục vi phạm nói trên trong vòng ba mươi (30) ngày kể từ khi nhận được thông báo bằng văn bản từ Bạn về vi phạm thực sự, xác định cụ thể bản chất của vi phạm. Chúng tôi có thể tạm ngưng hoặc hủy tài khoản của bạn mà không cần thông báo hoặc hoàn tiền cho bạn nếu bạn vi phạm Thỏa thuận này. Nếu tài khoản của bạn bị hủy, Info247 có quyền xóa thông tin tài khoản của bạn cùng với bất kỳ cài đặt tài khoản nào từ máy chủ của chúng tôi mà KHÔNG có trách nhiệm hoặc thông báo cho bạn. Khi thông tin tài khoản và cài đặt tài khoản của bạn bị xóa, Bạn sẽ không thể khôi phục dữ liệu này và Bạn sẽ mất quyền truy cập vào tất cả nội dung của mình (ngoại trừ nội dung được lưu trữ / xuất bản cho các trang web của bên thứ ba, dữ liệu đó sẽ vẫn giữ nguyên các trang web bên theo các điều khoản và điều kiện của trang web đó). Nếu bạn hủy dịch vụ trước khi kết thúc thời gian đăng ký trả tiền hiện tại của bạn, việc hủy của bạn sẽ có hiệu lực ngay lập tức. B. Info247 có quyền (i) sửa đổi hoặc ngừng, tạm thời hoặc vĩnh viễn, Dịch vụ (hoặc bất kỳ phần nào) và (ii) từ chối bất kỳ / tất cả việc sử dụng Dịch vụ hiện tại và trong tương lai, đình chỉ hoặc chấm dứt tài khoản của bạn và xóa và loại bỏ bất kỳ nội dung nào của bạn trong Dịch vụ nếu chúng tôi cho rằng bạn đã vi phạm các Điều khoản này. Info247 sẽ sử dụng những nỗ lực hợp lý để liên hệ trực tiếp với bạn qua email để cảnh báo bạn trước khi tạm ngừng hoặc chấm dứt tài khoản của bạn. Bất kỳ hoạt động gian lận, lạm dụng hoặc bất hợp pháp bị nghi ngờ có thể là cơ sở để chấm dứt ngay việc sử dụng Dịch vụ của bạn và có thể được chuyển đến cơ quan thực thi pháp luật. Info247 sẽ không chịu trách nhiệm với bạn hoặc bất kỳ bên thứ ba nào về bất kỳ sửa đổi, tạm ngừng hoặc ngừng Dịch vụ nào.'
    },
    optionalJob:{
      all:'Tất cả ngành',
      realEstate:'Bất động sản',
      iT:'CNTT & Viễn thông',
      insurance:'Bảo Hiểm',
      freightForwarders:'Giao nhận vận tải',
      pGovernmentService:'Dịch vụ công & nhà nước',
      ecommerce:'Thương mại điện tử',
      pMedical:'Dược & Y tế' ,
      construct:'Xây dựng',
      fBanking:'Tài chính/Ngân hàng',
      fBeverages:'Thực phẩm & Đồ uống',
      entertain:'Giải trí',
      fConsumption:'Tiêu dùng nhanh',
      mAdvertisement:'Quảng cáo/Truyền thông',
      agriculture:'Nông nghiệp',
      fintech:'Fintech',
      rCommercial:'Bán lẻ & thương mại',
      lLegal:'Luật/Pháp lý',
      bCHealth:'Làm đẹp, Mỹ phẩm & Sức khoẻ',
      hMotels:'Khách sạn & nhà nghỉ',
      energy:'Năng lượng',
      travel:'Du lịch vận tải',
      education:'Giáo dục'
    },
    newspaper: {
      cateLink: 'Link category',
      authorXpath: 'Author Xpath',
      contentParentXpath: 'Content Parent Xpath',
      descriptionXpath: 'Description Xpath',
      imageXpath: 'Image Xpath',
      linkDomain: 'Link Domain',
      linksXpath: 'Link Xpath',
      nameDomain: 'Domain',
      textXpath: 'Content Xpath',
      timeRegex: 'Time Regex',
      timeXpath: 'Time Xpath',
      titleXpath: 'Title Xpath',
      deleteConfirmation: 'Bạn có chắc chắn xóa bản ghi?',
      textSuccess: 'Xóa thành công',
      textError: 'Xóa thất bại',
      btnAdd: 'Thêm mới',
      successText: 'Thành công',
      failText: 'Thất bại',
      numberOrder: 'Mức độ ưu tiên',
      siteMap: 'Site map',
      rss: 'RSS',
      search: 'Tìm kiếm',
      createDate: 'Ngày tạo',
      createBy: 'Người tạo',
      noDataMatching: 'Không có kết quả phù hợp!',
      noData: 'Không có dữ liệu!',
      status: 'Trạng thái',
      actions: 'Hành động',
      verifiedDateCvt: 'Ngày kiểm tra',
      thread: 'Tiến trình',
      totalInit: 'Khởi tạo',
      totalTrue: 'Thành công',
      totalFalse: 'Thất bại',
      totalCategory: 'Tổng',
      modifiedDate: 'Ngày sửa',
      verifyStatus: 'Trạng thái'
    }
  },

  en: {
    reportCalendarUpdate: 'Setting report calendar',
    dashboard: 'Dashboard',
    compare: 'Comparison',
    trending: 'Trending',
    report: 'Report',
    exportFileReport : 'Export file',
    reportCalendar : 'New report calendar',
    reportList : 'Report list',
    reportCalendarList : 'Report calendar',
    manager: 'Manager',
    other : 'Other',
    trialDashboard : 'Trial',
    project : 'Project',
    projectList : 'Project List',
    updateProject: 'Setting project',
    createProject : 'Create new project',
    functionList : 'Functions List',
    limitFunction : 'Limit Function',
    managerKeywords: 'Keyword Management',
    managerUsers: 'Account Management',
    managerPackages: 'Plan Management',
    manageNewspaper: 'Website Management',
    manageArticle: 'Data Managements',
    registerPackage: 'Plan Upgrade',
    packageDetail: 'Your current plan',
    historyRequest: 'Request history',
    sourceData: 'Sources',
    warnings: 'Warnings',
    listWarnings: 'List Warnings',
    messageWarning: 'Message warning',
    groupAccount : 'Group account',
    personalAccount : 'Personal account',
    createSourceDataFb: 'Add new source from Facebook',
    createSourceDataWebsite: 'Add new source from Website',
    trialJobMange: 'Trial job Manage ',
    dataSourceTracking : 'Data source tracking',
    news: 'News',
    setting: 'Setting',
    generalSetting:'General Setting',
    articlesByTopic : 'Articles by topic',
    timeline:'Articles TimeLine',
    isBookMark: 'Bookmark',
    isSpam: 'Spam',
    account: 'Account',
    password: 'Password',
    rePassword: 'Confirm Password',
    organizationName: 'Company',
    city: 'Province/ City',
    district: 'District/ Town',
    subDistrict: 'Suburb/ Village',
    houseNumber: 'Street number',
    fullAddress: 'Address',
    zipCode: 'Zip Code',
    adminAccount: 'Admin account',
    phoneNumber: 'Phone number',
    organizationType: 'Type of business/ Type of organization',
    expiredDate: 'Expired date',
    streamUrl: 'Link stream',
    firstName: 'Last name',
    lastName: 'First name',
    birthday: 'Date of  birth',
    email: 'Email',
    fullName: 'Full name',
    gender: 'Gender',
    activeStatus: 'Status',
    functionName: 'In this Plan',
    functionAlias: 'Display name',
    functionApiPrefix: 'Function Api Prefix',
    functionScreenPrefix: 'Screen Path',
    metadata: 'Metadata',
    businessPackage: 'Current Plan',
    totalKeyword: 'Number of keywords',
    totalData: 'Data Volume ',
    totalSubAccount: 'Number of sub-account',
    totalDays: 'Days',
    price: 'Price',
    displayOrder: 'Display order',
    topicName: 'Topic name',
    topicGroupName: 'Project name',
    homeTown: 'Permanent address',
    priority: 'Priority level',
    groups: 'Groups',
    relationship: 'Relationship',
    type: 'Type',
    url: 'Url',
    topic: 'Topic',
    keyword: 'Keyword',
    name: "Name",
    facebookId: "Facebook Id",
    link: "Link",
    article: 'Article',
    website: 'Website Name',
    time: 'Time',
    keywordDependent: 'Sub-keywords',
    businessTarget: 'Your industry',
    oldPassword: "Current password",
    urlFacebook: 'Custom Facebook sources',
    urlWebsite: 'Custom Website sources',
    btnPreview: 'Preview',
    newPassword: 'New Password',
    listSourceFb: 'List source Facebok',
    listSourceWebsite: 'List source Website',
    packageData: 'Package data',
    settings: 'Settings',
    download: 'Download',
    capacity: 'Capacity',
    informationResource: 'Infomation resource',
    topNews: 'Top news',
    topDomain: 'Top domain',
    sourceSpecial: 'Source special',
    totalDataCollected: 'Total data collected',
    add : 'Add',
    upload: 'Upload',
    sampleFile: 'Sample File',
    tool: 'Tool',
    statistics: 'Statistics',
    all: 'All',
    onlySupportsUpload:'Only supports upload .xlsx, .xls, .csv suffix files',
    onlySupportOneFile: 'Only support uploading one file!',
    noData: 'No data',
    demoGraphic: 'Demo graphic',
    noPermission: 'Please upgrade your plan to use this feature',
    manageSpread: 'The spread of the article',
    manageArticleSpread: 'Statistical chart',
    //button
    widget: {
      title: 'Manager Widget',
      textDelete: 'Are you sure you want to delete widget information: ',
      textSuccess: 'Widget successfully removed: ',
      create: 'Create successfully widget',
      update: 'Update successfully widget',
      createWidget: 'Create Widget'
    },
    hashtag: {
      search: 'Search',
      topHashtag: 'Top Hashtag',
      seeMore: 'See more',
      share: 'Share',
      comment: 'Comment',
      result: 'Result',
      download: 'Download',
      from: 'From',
      post: 'post',
      numberOfTurns: 'Number of turns',
      recentSearches: 'Recent searches'
    },
    shareOfVoice: {
      correlation: 'Correlation of news between topics',
      quantity: 'Quantity of articles mentioned',
      correlationOfMentions:'Correlation of mentions between topics over time',
      shadesOfRatio: 'Shades ratio of each topic',
      shadesCorrelation: 'Shades correlation between topics',
      genderOfRation: 'Gender ratio of each topic',
      genderCorrelation: 'Gender correlation between topics',
      agesOfRation: 'Ages ratio of each topic',
      agesCorrelation: 'Ages correlation between topics',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      update: 'Update',
      unChecked: 'Unchecked'
    },

    facebookManager: {
      sentRequestCreate: 'Sent request to add new Facebook source',
      sentRequestUpdate: 'Sent a request to update the Facebook source'
    },
    trial : {
      manageJob : 'Job manage',
      job : 'Job',
      addTopic : 'Add topic',
      addKeyword : 'ADD KEYWORD',
      manage : 'Manage',
    },
    warning: {
      emailInvalid: 'Email invalid: ',
      number: 'Number',
      warningName: 'Warning name',
      source: 'Source',
      rules: 'Rules',
      formality: 'Formality',
      status: 'Status',
      createdBy: 'CreatedBy',
      active: 'Active',
      inActive: 'inActive',
      showing: 'Showing',
      content: 'content',
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      share: 'Share',
      comment: 'Comment',
      equal: 'Equal',
      lessThan: 'Less than',
      lessThanOrEqual: 'Less than or equal',
      moreThan: 'More than',
      moreThanOrEqual: 'More than or equal',
      merge: 'merge',
      createRulesWarning: 'Create rules warning',
      updateRulesWarning: 'Update rules warning',
      filterSmart: 'Filter smart',
      sendMail: 'Send mail',
      addEmail: 'Add email',
      rulesWarning: 'Rules warning',
      project: 'Project',
      topic: 'Topic',
      condition: 'Condition',
      createWarning: 'Create warning',
      updateWarning: 'Update warning',
      cancel: 'Cancel',
      allSources: 'All sources',
      news: 'News',
      forum: 'Forum',
      anyPost: 'Any post',
      negativeContent: 'Negatie content',
      positiveContent: 'Positive content',
      neutralContent: 'Neutral content',
      totalCollectedPost: 'total collected post',
      ofAArticle: 'of a article',
      success: 'success',
      deleteWarningSuccess: 'Delete warning success',
      deleteWarning: 'Delete warning',
      infomation: 'Infomation',
      createdDate: 'Created date',
      recentlyModifited: 'Modifited',
      copyWarning: 'Copy warning',
      copyWarningSuccess : 'Successfully copied warning',
      editRulesWarning: 'Edit rules warning',
      updateStatusSuccess: 'Update status success',
      doNotFullInfomation: 'Do not full infomatioon'
    },
    source: {
      require: 'Require',
      sourceName: 'Source name',
      url: 'url',
      description: 'Description',
      status: 'Status',
      newRequire: 'Required by',
      sourceList: 'Source list',
      active: 'Active',
      inActive: 'Inactive',
      other: 'Other',
      profile: 'Profile',
      fanpage: 'Fanpage',
      group: 'Group',
      update: 'Update',
      create: 'Create',
      delete: 'Delete',
      showing: 'Showing',
      content: 'Content',
      enterThePath: 'Enter the path',
      close: 'close',
      textSystem: 'The system will generate source name if source name is empty',
      requireCode: 'Require code',
      sentRequire: 'Sent require',
      gettingData: 'Getting data',
      reject: 'Reject',
      newspaper: 'Newspaper',
      news: 'News',
      placeHolder: 'Enter the source name to make it easy to remember',
      placeHolderDescription:'More description of this source. (Optional)',
      notGettingData: "Stop getting data",
      received: 'Received'
    },
    button: {
      downloadData: 'Export data',
      quickReportExport: 'Download report',
      all: 'All',
      watching: 'Viewing',
      seeAll : 'View all',
      seeMore : 'View more/ More',
      warningManagement: 'Alert settings',
      newWarning: 'New alert',
      trackingToSpecialNews: 'Subscribe to special news/sources',
      manageNotificationsAccount : 'Email(s) receive notification',
      shadeRules: 'Sentiment rule',
      deleteAll : 'Clear all',
      createNew : 'New',
      update : 'Update',
      addAnAccount : 'Add account',
      sendRequire : 'Send require',
      closed : 'Closed',
      cancel : 'Cancel',
      copyLink : 'Copy link',
      originalPost : 'Original post',
      threshold: 'Setting notify'
    },
    //title
    title: {
      readMore: 'Read more',
      readLess: 'Read less',
      ages: 'Ages',
      time: 'Time',
      active: 'Actives',
      gender : 'Gender',
      shades: 'Sentiment',
      feeling: 'Reaction',
      volatility: 'Fluctuation',
      mentioned: 'Mention',
      comment: 'Discuss',
      lastPeriod: 'Previous period',
      shadesBySocial: 'Sentiment by channel',
      topic: 'Topic',
      positive: 'Positive',
      negative: 'Negative',
      neutral: 'Neutral',
      share: 'Share',
      content: 'Content',
      interactive:'Interactive'
    },
    dashboardAnalytics : {
      positive : 'Positive',
      neutral : 'Neutral',
      negative : 'Negative',
      content : 'Content',
      socialNetwork : 'Social Network',
      electronicMedia : 'Electronic Media',
      otherSources : 'Other Sources',
      forumOtherSources : 'Forum & Other source',
      numberOfPost : 'Number of posts',
      onlineNewspaper : 'Online newspaper',
      textSuccess : 'Download data successfully',
      textPackage : 'You are not using any service package yet!',
      restorePassword : 'Your password restore',
      textInput : 'Please enter your email address and we will send you instructions on how to reset your password.'
    },
    managePackage:{
      h5:'History & processing status of plan extension, upgrade and renewal requests.',
      place:'Search...',
      userName : 'User name',
      namePackage: 'Package name',
      content:'Plan details',
      meta:'Plan description',
      createDay:'Created date',
      status:'Status',
      action:'Action',
      receive:'Receive',
      agree:'Agree',
      refuse:'Refuse',
      cancelled:'Cancelled',
      titleCancel:'Cancellation Confirmation',
      text:'Please confirm you are about to cancel the upgrade request?',
      yes:'Yes',
      can:'Cancel',
      text1:'Upgrade request cancelled successfully',
      a:'Cancel request'
    },
    adminUser : {
      job:'Job/Industry',
      fullName : 'Full Name',
      organizationName : 'Organization Name',
      phoneNumber : 'Phone Number',
      gender : 'Gender',
      birthday : 'Birthday',
      operationStatus : 'Operation Status',
      password :'Password',
      confirmPassword : 'Confirm Password',
      city:'City',
      district:'District',
      spanNoOption:'There are no valid values',
      subDistrict:'Ward',
      houseNumber:'Apartment Number',
      address:'Address',
      updateUser:'Update account successfully',
      createUser:'Create',
      classify : 'Classify',
      other : 'Other',
      male : 'Male',
      female : 'Female',
      notActivated :'Not activated',
      active : 'Active',
      lock : 'Lock',
      back : 'Back',
      more : 'More',
      accountSuccess : 'Create account successfully',
      deleteConfirmation : 'Delete confirmation',
      textDl : 'Are you sure that you want to delete the account ',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textSuccess : 'Delete organization successfully',

    },
    adminPackage : {
      addPackage: 'Add service package',
      search : 'Search ...',
      namePackage : 'Package name',
      totalKeyword :'Keyword number',
      totalSubAccount : 'Account number',
      totalData : 'Data number',
      numberOfDays : 'Number of days',
      price : 'Price',
      action : 'Action',
      basicPackage : 'Basic package',
      allowUsersToRegister : 'Allow users to register',
      subAccountNumber : 'Sub-account number',
      displayOrder : 'Display order',
      additionalInformation : 'Additional information',
      confirmDelete : 'Confirm delete',
      textDelete : 'Do you want to delete the service pack',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textSuccess : 'Remove limit function successfully',
      textAgree : 'Agree',
      textRefuse : 'Refuse',
      textUpgrade : 'Are you sure you want to cancel the upgrade request ',
      acceptTextUpgrade : 'Yes',
      textSuccessUpgrade : 'Package upgrade request successful',
      textRefuseUpgrade : 'Successfully refused the request to upgrade the package',
      receive : 'receive',
      cancelled : 'cancelled',
      confirmCancel : 'Confirm cancel',
      expiredDate: 'Expired date',
      approve: 'Approve'
    },
    managerKeyword: {
      priorityLevelSuccess: 'Priority update successful',
      priorityLevelReject: 'Priority should not exceed 50',
      managerKeywordTitle: 'Keyword management',
      addNewCampaign: 'New project',
      otherTopics: 'Other topics',
      combinedAction: 'Action',
      combinedActionPlaceholder: 'Select compound action',
      campaignUpdate: 'Update project name',
      deleteCampaign: 'Delete project',
      share: 'Share',
      deleted : 'Deleted',
      update : 'Update',
      addNewTopic: "Add new topic",
      topic: 'Topic',
      keyword: 'Keyword',
      informationResource: 'Information Resource',
      dateCreated: 'Created date',
      creator: 'Created by',
      action: 'Action',
      notAcceptedYet: ' Not accepted',
      your: 'your',
      other: 'other',
      rival: 'rival',
      all: 'All',
      shareBy: 'Share by',
      shareThisThread: 'Share this thread',
      accept: 'Accept',
      refuse: 'Decline',
      changeTheme: 'Change topic',
      hideTopic: 'Hide Topic',
      showTopic: 'Show Topic',
      bookmarkTopicsAsFavorites: 'Mark topics as favorites',
      removeFavoriteTopic: 'Remove favorite topics',
      deleteTopic: 'Delete topic',
      copyTheme: 'Copy topic',
      changeTheSubject: 'Change topic',
      turnOffNoti: 'Turn off notification',
      turnOnNoti: 'Enable notification',
      titleShare: 'Share this project to other users',
      placeholderAction: 'Select Compound Action',
      addTitle: 'More Campaigns',
      updateTitle: 'More Campaigns',
      nameCampaign: 'Name Campaign',
      spanPopup:'You can add more topics and keywords after creating this new project',
      sharedBy: 'Shared by  ',
      btnUpdate:'Update',
      btnCreate:'Create',
      close:'Close',
      switchGroupsTopic:'Switch topic group',
      placeSelect:'Select topic group',
      back:'Back',
      spanText:'A topic can include many main keywords',
      topicName:'Topic Name',
      topicTo:'This topic is related to',
      you:'You',
      spanText1:'All information collected will include this keyword below. Sub-keywords support more accurate information gathering',
      mainKey:'Keyword',
      subKey:'Secondary keyword',
      placeInput:'Brand name, product, project, issues, etc. that you want to monitor ....',
      placeSubKey: 'Characteristics of the main keyword',
      addKey:'Add keywords',
      deleKey: 'Delete keyword',
      removeKey: 'Remove Key',
      spanText2: 'All information collected will be',
      extrude:'Decline',
      spanText3: 'the content contains the following keywords',
      placeText: 'Posts containing spam keywords will be excluded from the collection.',
      shareKey:'Share keywords',
      emailShare: 'Email sharing',
      boxShare : 'Share your choices',
      boxCopy : 'Copy selections',
      boxMove : 'Move selections',
      boxCompare : 'Compare selections',
      boxDelete : 'Delete selections',
      show : 'Show',
      hide : 'Hide',
      textTheme : 'success theme',
      turnOn : 'On',
      turnOf : 'Off',
      textNotifi : 'success notification',
      textRefuse : 'Decline sharing topic :',
      textShare : 'Sharing the success',
      textAdd : 'Successfully added new',
      textKeyword : 'The main keyword cannot be left blank',
      textKeyword2 : 'The main keyword must not be the same as the exclusion keyword.',
      textSource : 'Must select at least one source',
      textTheme2 : 'Subject cannot be left blank',
      add : 'Add',
      textTheme3 : 'Topics with at least 1 keyword',
      textTheme4: 'Sources width at least 1 input',
      textLength : 'Length exceeds 20 characters',
      titleCampaign : 'Campaign Confirmation',
      textDeleteCampaign : 'Are you sure to delete the campaign',
      acceptText : 'Confirm',
      cancelText : 'Cancel',
      textDeleteSuccess : 'Successfully deleted the campaign',
      textMoveSuccess : 'Move the subject successfully',
      titlePooledShare : 'Pooled sharing confirmation',
      textPooledShare : 'Are you sure to perform the pooling share action ?',
      titlePooledCopy : 'Merge Copy Confirmation',
      textPooledCopy : 'Are you sure to perform the pooled data copy action ?',
      titlePooledMove : 'Compound Migration Confirmation',
      textPooledMove : 'Are you sure to perform the compound move action ?',
      titlePooledDelete : 'Confirm delete merged',
      textPooledDelete : 'Are you sure to perform the combined delete action ?',
      titlePooledCompare : 'Confirm the pooling comparison',
      textPooledCompare : 'Are you sure to perform the pool comparison action ?',
      textShareThemeSuccess : 'Share success topic',
      textDele : 'Successfully cleared selections',
      textFavourite : 'success favorite theme',
      textDeleSuccess : 'Delete topic successfully',
      titleDelete : 'Confirm delete',
      textFavorite : 'You want to mark the topic as favorite',
      textDelete : 'Are you sure you want to delete the topic :',
      delete : 'Delete',
      textCopy : 'Successfully copied the theme',
      textCampaign : 'Campaign cannot be empty',
      textCampaign2 : 'Campaign up to 100 characters',
      textCampaign3 : 'success campaign ',
      btnPreview: 'Preview',
      notEstimate: 'Not estimate yet',
      cannotEstimate: 'Can not estimate',
      dataLast30Days: 'Data in last 30 days',
      dataLast7Days: 'Data in last 7 days ',
      dataLast3Days: 'Data in last 3 days ',
      avgTime: 'Average data time ',
      posts: 'Posts',
      minute: 'minutes',
      priority: 'Priority level'

    },
    accountUser:{
      changepass:'Change the password',
      continue : 'Continue',
      textChangePassword : 'If you think someone might know your old password, you should sign out of any phone or computer.',
      logOut : 'Log out all devices',
      maintain : 'Keep login',
      textSuccessMaintain : 'Updated password and stay logged in',
      textLogOut : 'Successfully logged out all devices',
      notifySucces:'Password update successful',
      titleAccountUser:'Account management',
      btnAddAcc:' Add account',
      search:'Search ....',
      nameUser:'Username',
      fullName:'Full name',
      phoneNum:'Phone number',
      sex:'Gender',
      birthday:'Date of birth',
      statusUser:'Operation Status',
      passUser:'Password',
      confirmPass:'Confirm Password',
      city:' Province/ City',
      district:'District/ Town',
      spanNoOption:'Invalid values',
      subDistrict:'Village/ Block',
      houseNumber:'Street number',
      address:'Address',
      updateUser:'Update',
      createUser:'Create',
      backUser:'Back',
      actionUser:"Action",
      titleDele:'Delete Confirmation',
      textDele:'Are you sure you want to delete this account?',
      acceptText:'Delete',
      cancelText:'Cancel',
      text1:'Company removed successfully',
      unActive:'Inactive',
      active:'Not activated',
      lock:'Lock',
      otherUser:'Other',
      male:'Male',
      female:'FeMale',
      unActiveUsers:'Not activated',
      activeUsers:'Work',
      lockUser:'Locked',
      btnUpdate : 'Update',
      btnAdd : 'Add',
      textSuccess : 'success account ',
      account : 'Account',
      img : 'Avatar',
      editImg : 'Edit photo',
      editProfile : 'Edit information',
      displayName : 'Display Name',
      desDisplayName : 'Show in the function',
      organizationName : 'Organization Name',
      desOrganizationName : 'User organization name',
      email : 'Email',
      desEmail : 'Used for login and notifications',
      phoneNumber : 'Phone number',
      desPhoneNumber : 'Send notifications and validate',
      editPassword : 'Edit password ',
      desEditPassword : 'The master account has change permissions to subordinate accounts created by the master account.',
      addPassword : 'Create a new password',
      add : 'Create',
      updateImg : 'Update avatar',
      back : 'Back',
      update : 'Back',
      titlePassword : 'Edit new password',
      newPassword : 'New password',
      desNewPassword : '6-12 characters, including letters, numbers and capital letters',
      saveChanges : 'Change the password',
      close : 'Closed',
      editPasswordSuccess : 'Password update successful',
      textImg : 'You have not selected your profile picture yet',
      deleteAccount : 'Delete account',
      desDeleteAccount : 'Deleting a member\'s account will remove this account from the list of members and stop all access and authority of this account to the data created within the management of the master account.',
      delete : 'Delete',
      list : 'Members list',
      addList : 'Add members',
      updatePassword : 'Password update successful',
      doNotDelete : 'Can not delete team leader account',
      deleteAccountSuccess: 'Delete account successfully',



    },
    packageUpgrade:{
      limit:'In this plan:',
      numberFolow:'Number of keywords',
      keyword:'Keyword',
      numberSubKey:'Number of sub-keywords',
      dayUser:'Date of use',
      limitData:'Data Volume',
      createAcc:'Create Sub-accounts',
      yes:'Yes',
      no:'No',
      cost:'Cost',
      vnd:'VND',
      feature:'Feature',
      request:'Request',
      titlePackage : 'Submit a request to sign up for a package',
      text1 : 'You have subscribed to the package',
      text2 : 'please wait for approval',
      acceptText : 'About the request page',
      cancelText : 'Closed',
      text3 : 'yours will expire on',
      text4 : 'yours has expired. To keep track of new data, renew your plan now.',
      titleSuccess : 'Submit request successfully',
      text5 : 'Your request has been sent to our customer service team.\n' +
        'We will process it soon and get back to you. \n',
      receive : 'Receive',
      agree : 'Agree',
      refuse : 'Refuse',
      cancelled : 'Cancelled',
      //data
      theWholeAccount: 'The whole account',
      inAMonth: 'In a month',
      account: 'Account',
      packageData: 'Package data',
      present: 'Present',
      toDay: 'today',
      data: 'Data',
      thisPeriod: 'This period',
      remaining: 'Remaining',
      expired: 'Expired',
      day: 'day',
      extend: 'Extend'
    },
    informationService:{
      generalInformation:'General info',
      nameInfo:'Username',
      organize:' Firm',
      servicePack:'Package',
      chargeAccordingTo:'Charge by',
      month:'Month',
      expirationDate:'Expiry date',
      expired:'Expired',
      key:'key word',
      newMonth:'monthly post',
      accFolow:'tracking account',
      manipulation:'Action',
      requestPackage:'Please extend your plan',
      package:'Package/ Plan',
      used:'In use',
      upgrade:'Upgrade',
      keyB:'Key word',
      dataMonth:'Data/ monthly',
      member:'Member',
      numberDay:'Number of days of use',
      price:'Price',
      limit:'Limitation',
      titlePackage:'Service pack has expired',
      textPackage:'Do you want to renew your plan?',
      acceptText:'Confirm',
      cancelText:'Cancel',
      titleRequest:'Submit request successfully',
      textResquest:'Your request has been forwarded to the Info247 customer service team.\n'+' We will take care of it as soon as possible and get back to you.',
      acceptText1:'About the request page',
      cancelText1:'Closed',
      titlePackage1: 'The request is waiting for approval.',
      acceptText2:'Go to request page',
    },
    generalSettingMenu:{
      isCurrentDevice:'On this device',
      addressLogIn : 'Address you logged in',
      Unknown : 'Unknown',
      logOut : 'Sign out the device',
      textLogOut : 'Do you want to sign out the device ',
      logOutSuccess : 'Device successfully logged out',
      btn1:'Organization Info',
      btn2:'Notification',
      btn3:'Display',
      btn4:'Rules',
      btn5:'Version',
      btn6:'Log out',
      textLabel:'Receive account and bill notifications',
      language:'Language',
      vn:'Vietnamese',
      textNoti:'Notifications let you know changes to your data in a timely manner so you can react to them quickly.',
      content:'General content',
      warning:'Warning',
      titileBtn4:'Terms of use',
      labelBtn4:'Current version',
      labelDate:'Update date',
      changepass:'Change the password',
      textBtn5:'Info247 is a technology product of Limited Liability Company DeepBlue Technology',
      acc:'On this device',
      minuteAgo:'minute ago',
      hoursAgo:'hours ago',
      daysAgo:'giờ trước',
      lastMonth:'last month',
      justNow:'just now'
    },
    compareBranding:{
      selectCompare: 'Select to compare',
      compare: 'Comparison',
      save: 'Save results',
      selection: 'Select',
      selectionCompareBranding: 'Comparison',
      topicOther: 'Other topics',
      numberOfMentions: 'Number of mentions',
      allOfChannel: 'All channels',
      newsChannel: 'News',
      addCompare: 'More column',
      textAmount : 'Overcome the number of comparisons',
      textPosition : 'Invalid pin position',
      textTheme : ' Thread is pinned :',
      pin : 'Pin',
      unpin : 'Unpin',
      textSuccess : ' success theme',
      textChoose : 'The topic of comparison has been selected',
      textReport : 'Export success report',
      textTop5 : 'Top 5 meaningful words associated with brands',

    },
    managermentTrending:{
      contentMentioned:'Content Mentioned',
      contentTrending: 'Trending content',
      refresh: 'Refresh',
      keywordMentions: 'Keyword mentions',
      TrendingsMentionInSocial: 'Trendings mention in social',
      value:'Value',
      trendDevelopment:'Trend development',
      totalInteractiveContent:'TOTAL INTERACTIVE CONTENT',
      totalNumber:'Total number of mentions',
      post:'Post',
      interactive:'Interactive',
      titleChart:'PERFORMANCE PERFORMANCE STATISTICS',
      titleTable:'Top Website Posting Sources',
      webName:'Website source name',
      interactionOccupies:'Interaction occupies',
      posts:'Posts',
      facebookName:'Facebook source namer',
      titleTableFace:'Top Facebook sources'
    },
    warningManager : {
      notifyUpdateSucces:'Update the rule of shades successfully',
      warning : 'Warning',
      searchWarningContent :'Search alert content',
      list : 'List',
      status : 'Status :',
      category : 'CATEGORYS',
      allWarning : 'ALL ALERTS',
      statusAll : 'All',
      statusRead : 'Read',
      statusUnread : 'Unread',
      contentWarning : 'CONTENT',
      setUp : 'Alert settings',
      listWarning : 'List of alerts',
      frequency : 'Frequency',
      manipulation : 'Manipulation',
      warningByContentShade : 'Alert content shades',
      sendMe : 'Send me',
      whenCollected : 'When any collected content is',
      newsPapers : 'Papers',
      other : 'Other',
      rightAway : 'Now',
      collectedContent : 'Collected content from',
      timeWarning : 'Alert time',
      contentWarningInfo : 'Alert content',
      back : 'Back',
      selectTime : 'Choose alert time',
      newSource : 'New Source',
      source : 'Source',
      note : 'Note',
      updateSource : 'Update source',
      createNewSource : 'Add new source',
      emailGetNotify : 'Email used to receive notifications',
      importEmail : 'Enter email address',
      act: 'Transactions',
      textEmailEmpty : 'Email cannot be empty',
      textEmailInvalidate : 'Email invalidate',
      textEmailWasRegistered  : 'The Email was registered',
      textSuccessfulNotification : 'Add account to receive successful notification',
      textShadeRules: 'The setting of positive and negative reviews helps the system to automatically evaluate more accurately. You can enter words that define the status of the article, including: adjectives describing the status, words that express specific emotional nuances related to the nature of the content.',
      autoEvaluate : 'Auto-evaluate',
      positiveWords : 'Positive words',
      negativeWords : 'Negative words',
      importAndPress : 'Import and press enter',
      deleteAllWarning : 'Delete all warning',
      remindDelete : 'Are you sure you want to remove all alerts?',
      textDeleteAll : 'Removed all alerts',
      textNotDeleteAll : 'Can\'t remove all alerts yet',
      textCopy : 'Copy path success',
      notification : 'Notifications',
      negativeNews : 'Negative News',
      generalNotification : 'General Notification',
      after15 : 'After 15 minutes',
      after30 : 'After 30 minutes',
      after60 : 'After  1 hour',
      allNotification : 'All Notification ',
      timeNotification : 'Time',
      contentNotification : 'Content',
      transactions: 'Transactions',
      newWarning : 'New Warning',
      allWarningMessage : 'All Warning',
      storageWarning : 'Storage Warning',
      textStorageWarning : 'Alert archived successfully',
      textNotifi : 'Successful notification setup',
      textDelete : 'Deleting account receive successful notification',
      titleDelete : 'Confirm delete',
      textDeleAccount : 'Are you sure you want to remove account',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      action : 'Action',
      titlePercent : 'Set negative percentage threshold',
      textSource : 'Sources can not be blank',
      add : 'Add new',
      update : 'Update',
      success  :'success',
      textDeleteSource : 'Successfully deleted source',
      textDelete2 : 'Are you sure you want to remove the source',
      text1 : 'Select at least one content source',
      text2 : 'Choose at least one shade',
      text3 : 'successful alert',
      text4 : 'failure warning',
      text5 : 'Clear warning successfully',
      text6 : 'Clear failure warning',
      text7 : 'Are you sure you want to remove the warning',
      text8 : 'Save success message',

    },
    exportFile: {
      textSuccessDelete : 'Successfully deleted report',
      apply : 'Apply',
      titleDownloadPooled : 'Pooled download confirmation',
      textDownloadPooled : 'Are you sure to perform the pooled report download action ?',
      titleDeletePooled : 'Confirm delete pooled',
      textDeletePooled : 'Are you sure to perform the delete report pooled action ?',
      errPooled : 'Select at least one report',
      downloadCheckbox : 'Download options',
      copyCheckbox : 'Copy options',
      deleteCheckbox : 'Delete options',
      hours : 'hour',
      week : 'Weekly',
      continue : 'Continue',
      pause : 'Pause',
      auto : ' run reports automatically',
      deleteSuccess : 'Successfully deleted report',
      copySuccess : 'Copy success report',
      deleteReport : 'Delete Confirmation',
      textDelete : 'You want to delete the report',
      updateSuccess: 'Successfully update report schedule',
      createSuccess : 'Successfully created new report schedule',
      edit : 'Edit report schedule',
      copy : 'Copy report schedule',
      delete : 'Delete the report calendar',
      daily : 'Daily',
      stt : 'NUMBER',
      nameExport : 'NAME REPORT',
      creator : 'CREATOR',
      status : 'STATUS',
      calendar : 'REPORT CALENDAR',
      action : 'ACTION',
      createDate : 'DATE CREATED',
      number :'Number of impressions ',
      endDate : 'Choose a time period',
      monday : 'Monday',
      tuesday : 'Tuesday',
      wednesday : 'Wednesday',
      thursday : 'Thursday',
      friday : 'Friday',
      saturday : 'Saturday',
      sunday : 'Sunday',
      createReportCalendar : 'Create report calendar',
      sendEmailTime : 'Email before this report expires',
      typesReport: 'Data type',
      topic: 'Topic',
      source: 'Source',
      exportReport: 'Export data',
      brandHealthByDay: 'Brand reputation - Daily',
      brandHealthByWeek: 'Brand reputation - Weekly',
      postFb : 'Posts Facebook',
      commentFb : 'Comment Facebook',
      postIg : 'Posts Instagram',
      commentIg : 'Comment Instagram',
      news : 'News',
      textReport : 'No report type selected',
      textSuccess : 'Export success report',
      newReport : 'Create a new report',
      nameReport : 'Report name',
      typeReport : 'Report Type',
      contentReport : 'Contents of the report:',
      dataRange : 'Data range:',
      cancel : 'Cancel',
      topicList : 'TOPICS',
      exportFile : 'Export report',
      reportName : 'Report name',
      all : 'All',
      contentConfiguration : 'Content configuration Email',
      sendEmail : 'Send email',
      sendFile : 'send attached report file',
      place : 'Enter report name',
      sendTo : 'Send to',
      sendToEmail : 'Send email',
      fileReport : 'Attach report file',
      title : 'Title',
      content : 'Content',
      reportCalendar : 'Create report calendar',
      autoReport : 'Set up automatic reports',
      editReportCalendar : 'Configure automatic reports',
      update : 'Update',
      frequency : 'Frequency',
      time : 'Time',
      endTimeReport : 'End time report',
      placeTime : 'Choose a time',
      project : 'Project',
      uploadListSources: 'Upload list sources',
      requiredFile: 'Required file',
      dragAndDropFileOrChoseFile: 'Drag and drop file or chose file',
      validateEmail: 'Email invalid'

    },
    userView:{
      email: 'Email address',
      userName: 'Name',
      phoneNumber: 'Phone number',
      organization: 'Company',
      birthDate: 'Date of birth',
      address: 'Address',
      userInfomation: 'Account infomation',
      edit: 'Edit',
      changePassword: 'Change Password',
      registerNotify: 'Sign up for email notifications',
      infomation: 'Account infomation',
      logOut: 'Logout'
    },
    articleTimeLine:{
      post:'POST',
      postLink:'View this day\'s news',
      projectNotTopic:'Project Not Topic',
    },
    articleDetail:{
      private:'Private group',
      result:'Result',
      articlesByTopic:'Articles By Topic',
      at:'At',
      from: 'From',
      contentMention: 'Mentioned',
      pages: 'Page',
      views: ' Display',
      content: 'Content',
      filter: 'Filter',
      sort: 'Sort',
      shades: 'Sentiment',
      filterByFeeling: 'Sort by sentiment',
      source: 'Source',
      topic: 'Topics',
      newsFeed: 'Newest ',
      newsOld: 'Oldest ',
      ascendingLevel: 'Ascending',
      decreaseLevel: 'Decrease',
      all: 'All',
      findByKeyword: 'Find by keywords...',
      postFacebook: 'Facebook posts',
      facebookComment: 'Facebook comments',
      commentFacebook: 'Facebook comments',
      postIg : 'Posts Instagram',
      commentIg : 'Comment Instagram',
      news: 'News',
      shadesContent: 'Content sentiment',
      share: 'Share',
      copy: 'Copy',
      origin: 'Original post',
      spam: 'Spam',
      save: 'Save',
      savePost: 'Save Post',
      unSavedChanges: 'Unsave Changes',
      findOrigin: 'Go to original post',
      priorityLevel: 'Priority level',
      markSpam: 'Mark spam',
      notSpam: 'Not spam',
    },
    articleBookmark:{
      selectAll:'Select All',
      project:'Project',
      savedContents: 'Saved news',
      topics: 'Topics',
      sort: 'Sort',
      sources: 'Source',
      time: 'Time' ,
      filterByShades: 'Filter by reactions',
      filterByKeyword: 'Filter by keyword...',
      news: 'News',
      postFacebook: 'Facebook posts',
      commentFacebook: 'Facebook comments',
      facebookComment: 'Facebook comments',
      all: 'All',
      exportToFile: 'Export data',
      shadesContent: 'Content shades',
      comment: 'Comment',
      share: 'Share',
      copy: 'Copy',
      origin: 'Origin',
      spam: 'Spam',
      saveContent: 'Save post/ news',
      unSaveContent: 'Unsave post/ news',
      filter: 'Filter',
      restore: 'Restore',
      titleTick : 'Mark spam',
      textTick : 'Are you sure it\'s spam?',
      acceptText : 'Confirm',
      cancelText : 'Cancel',
      textCopy : 'Copy path success',
      acceptText1 : 'Tick',
      like : 'Like',
      love : 'Love',
      wow : 'Wow',
      care : 'Care',
      sad : 'Sad',
      angry : 'Angry',
      rejectPost: 'Unsave post',
      textSave : 'Save message successfully',
      textUnsave : 'Unsaved message successfully',
      seveNotDone:'Save failed message',
      textDlData : 'Download data successfully',
      textRecovery : 'Successful news recovery',
      positive : 'Positive',
      negative : 'Negative',
      neutral : 'Neutral',
      titleRecovery : 'Restore news',
      textRecovery2 : 'Do you want to restore ? ',
      textTl : 'The current article is rated neutral',
      textTc : 'This post is currently being rated negatively',
      textTchc : 'This post is currently being rated positively',
      isSpamSuccess : 'Mark spam successfully',
      isSpamUnSuccess : 'Mark spam failed'
    },
    adminFbIcon : {
      title : 'Add sources from Facebook',
      addFb : 'Add Facebook',
      search : 'Search ...',
      formCSV : 'Form CSV',
      importCSV : 'Import CSV',
      saveData : 'Save',
      closePopup : 'Close',
      path : 'Path',
      textPath : 'Input path and press enter ...',
      nameFb : 'Name Facebook',
      form : 'Form',
      groupType : 'Group type',
      priorityLevel : 'Priority level',
      statusFb : 'Status',
      gender : 'Gender',
      address : 'Address',
      create : 'Create',
      update : 'Update',
      back : 'Back',
      female : 'Female',
      male : 'Male',
      normal : 'Normal',
      prioritize : 'Prioritize',
      specialPriority : 'Special priority',
      active : ' Active',
      inactive : 'Inactive',
      profilePage : 'Personal page',
      pageFb : 'Page Facebook',
      groupFb : 'Group Facebook',
      alone : 'Alone ',
      married : 'Married',
      other : 'Other',
      privateGroup : 'Private qgoup',
      publicGroup : 'Public group',
      type : 'Type',
      action : 'Action',
      text : 'No information found',
      add : 'Add',
      text2 : 'successful facebook information',
      text3 : 'Invalid type ',
      text4 : 'Successfully added new',
      notActive : 'Not active',
      lock : 'Lock',
      titleDelete : 'Confirm delete',
      textDelete : 'Are you sure you want to delete facebook account information :',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textSuccess : 'Account information deleted successfully',
    },
    adminWs : {
      title : 'Add sources from Website',
      addWs : 'Add new Website',
      formCSV : 'Form CSV',
      importCSV : 'Import CSV',
      status : 'Status',
      search : 'Search ...',
      save : 'Save',
      closed : 'Closed',
      update : 'Update',
      create : 'Create',
      back : 'Back',
      all : 'All',
      received : 'Received',
      processed : 'Processed',
      ready : 'Ready',
      scanning : 'Scanning',
      newspapers : 'Newspapers',
      news : 'News',
      other : 'Other',
      nameWs : 'Name Website',
      group : 'Group',
      action : 'Action',
      textIllegal : 'Invalid website type',
      textIllegalFb : 'Invalid facebook type',
      textSuccess : 'Successfully added new',
      titleDelete : 'Confirm delete',
      textDelete : 'Are you sure you want to delete website information :',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textDeleteSuccess : 'Account information deleted successfully',
      textManipulation : 'Successful manipulation',
      path : 'Path',
      catalogCode : 'Catalog code',
      type : 'Type Website',
      address : 'Address Website',
      configuration : 'Configuration',
      active : 'Active',
      inactive : 'Inactive',
      textFooter : 'Successful website',
      addFindSource: 'Created find source',
      cancelFindSource: 'Cancel find source'

    },
    adminUserICon : {
      title : 'Add account',
      search : 'Search...',
      account : 'Account',
      pass : 'Password',
      creatorCode : 'Creator code',
      creator : 'Creator',
      dateCreated : 'Date created',
      accountStatus : 'Account status',
      effect : 'Effect',
      action : 'Action',
      type : 'Account type',
      normal : 'Normal',
      prioritize : 'Prioritize',
      notUsedYet : 'Not used yet',
      wasUsed : 'Was used',
      effective : 'Effective',
      notEffective : 'Not effective',
      update : 'Update',
      create : 'Create',
      back : 'Back',
      other : 'Other',
      titleDelete : 'Confirm delete',
      textDelete : 'Are you sure you want to delete account information:',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textSuccess : 'Account information deleted successfully'
    },
    realtimeChart : {
      boxTime : 'Interval',
      boxData : 'Refresh data',
      placeTime : 'Choose a time period',
      placeTimeData : 'Select data refresh interval',
      titleData : 'Current data :',
      data : 'Data',
      text1p : '1 minute ago',
      text5p : '5 minute ',
      text10p : '10 minute ',
      text30p : '30 minute',
      text1t : '1 hour',
      text4t : '4 hours',
      text12t : '12 hours',
      text1day : '1 day',
      startDate: 'Start time'
    },
    permission : {
      title : 'Add function',
      search : 'Search ...',
      nameFunction : 'Name function',
      action : 'Action',
      displayName : 'Display name',
      additionalInformation : 'Additional information',
      update : 'Update',
      create : 'Create',
      back : 'Back',
      titleDelete : 'Confirm delete',
      textDelete : 'Are you sure you want to remove the limit function',
      acceptText : 'Delete',
      cancelText : 'Cancel',
      textSuccess : 'Remove limit function successful',
      add : 'Add',
      textUpdate : ' limit function successful',
      textDelete2 : 'Are you sure you want to delete',

    },
    projectAndTopic : {
      noteFavourite : 'No favorite projects yet',
      inputSourceInvalid: 'Source invalid: ',
      estimate : 'Estimate data',
      preview : 'Preview',
      sourceInvalid: 'Source invalid',
      topicGroupAlreadyExist: 'Topic groupd already exist!',
      endDateInvalid: 'End date invalid',
      isActive : 'Active',
      pause : 'Pause',
      favourite : 'Favourite',
      projects : 'Projects',
      updateProject: 'Setting topic',
      createNewProject : 'Create a new project',
      createNewTopic : 'Create a new topic',
      all : 'All',
      otherTopics : 'Other topics',
      topicC : 'TOPIC',
      createNewTopicC : 'CREATE NEW TOPIC',
      status : 'Status',
      info : 'INFORMATION',
      description : 'Description',
      creator : 'Creator',
      createDate : 'Create Date',
      viewStatistical : 'View statistical',
      viewNews : 'View news',
      editProject : 'Edit project',
      projectFavourite : 'Bookmark favorites',
      removeFavoriteGroupTopic: 'Remove project favourite',
      deleteProject : 'Delete project',
      keyword : 'KEYWORD',
      createBy : 'Share By',
      turnOn : 'Continue',
      turnOf : 'Cancel',
      crawl : 'data collection topic : ',
      editTopic : 'Edit topic',
      copyTopic : 'Copy topic',
      tickFavouriteTopic : 'Bookmark topics favorites',
      deleteTopic : 'Delete topic',
      cancelText : 'Cancel',
      update : 'Update',
      accept : 'Confirm',
      textFavourite : 'success favorite project',
      textSuccessDelete : 'Successfully deleted the project',
      textSuccessDelete2 : 'Successfully deleted the topic',
      titleDelete : 'Confirm project deletion',
      textDelete : 'Are you sure you want to remove the project',
      titleDelete2 : 'Confirm the deletion of the topic',
      textDelete2 : 'Are you sure you want to delete the topic',
      deleted : 'Deleted',
      textSuccessCopy : 'Successfully copied the theme',
      textKeyword : 'The main keyword cannot be left blank',
      textKeyword2 : 'The main keyword must not be the same as the exclusion keyword.',
      textTheme2 : 'Subject cannot be left blank',
      add : 'Create',
      textAdd : 'topic success',
      addProject : 'Create new Project',
      nameProject : 'Name the project',
      desNameProject : 'Project name can be: Name of a brand, a product/service, name of a campaign ',
      textTheme4 : 'Please choose at least 1 topic',
      desProject : 'Project description',
      desToDes : 'Project descriptions help you clearly define the goals of each project, distinguishing it from other projects in the portfolio',
      colorProject : 'Choose project color',
      desColor : 'Use color or icon help you are easy tognized and the analysis of the project in too the manager',
      timeFollow : 'Time period you want to track',
      startDate : 'Start day :',
      desStartDate : 'The data is collected starting from this date',
      selectTime : 'Choose a start date',
      endDate : 'End date : ',
      desEndDate : 'Data collection end date.',
      selectTime2 : 'Choose an end date',
      addTopicFirst : 'Create your first topic',
      savaProject : 'Save project',
      textCampaign : 'Project name cannot be left blank',
      textCampaign2 : 'Project name up to 100 characters',
      textSuccess : 'project success',
      configurationTopic : 'Configuration topic',
      addTopic : 'Add Topic',
      nameTopic : 'Topic name :',
      availableProjects : 'Add to an availabel project',
      project : 'Project : ',
      chooseProject : 'Choose project',
      mainKey : 'Main keyword',
      desMainKey : 'Keyword brand name, product or service, campaign name or issue to track',
      subKey : 'Sub keyword',
      desSubKey : 'The keywords describe more specific, detailed and clear about the brand, product, and campaign to optimize the volume of articles.',
      removeKey : 'Remove keyword',
      desRemoveKey : 'Posts containing these spam or spam keywords will not be collected.',
      placeMainKey : 'Brand Name, Product,  ....',
      keyword1 : 'Keyword',
      placeSubKey : 'Attribute characteristics of sub-keywords',
      placeRemoveKey : 'Remove keyword...',
      addKeyword : 'Add keyword',
      source : 'Source',
      selectedSource: 'Topic news data is collected from',
      textSource : 'Enter more data sources you want to request special tracking for',
      allSource : 'All source',
      newsPapers : 'Newspapers',
      forum : 'Forum',
      specialSource : 'Special source',
      addSource : 'Add new special source',
      saveTopic : 'Save topic',
      textLength : 'Length exceeds 20 characters',
      textTheme3 : 'Topics with at least 1 keyword',
      addNewKeyword : 'Create new keyword',
      saveKey : 'Create keyword',
      deleteKey : 'Delete keyword',
      saveProject : 'Save project',
      addToAnExistingProject:'Add to an existing project',
      sharedBy: 'Shared By',
      createNewKeyword: 'Create new keyword'
    },
    overview: {
      tip: 'Suggestion',
      contentTip: 'You can do action A to get B faster.',
      data: 'Data',
      today: 'Today',
      comparedToYesterday: 'Compared to yesterday',
      viewDataPackages: 'View data packages',
      topTopic: 'Top topic',
      viewAllTopics: 'View all topics',
      hours: 'hours',
      infomationHighlights: 'Infomation highlight',
      seeMore: 'See more',
      keyword: 'Keyword',
      shades: 'Shades',
      interactive: 'Interactive',
      comment: 'Comment',
      share: 'Share',
      topic: 'TOPIC',
      project: 'PROJECT',
      post: 'POSTS',
      negative: 'Negative',
      positive: 'Positive',
      neutral: 'Neutral',
      warning: 'Warning!',
      greatNews: 'Greate news!',
      caution: 'Caution!',
      contentGreat: 'Your data has a good positive rate.',
      contentWarning: 'The number of negative news articles has increased significantly in the last 24 hours.',
      contentCaution: 'The number of neutral news articles has increased significantly in the last 24 hours.',
      numberOfImpressions: 'Number of impressions'
    },

    popupConfirm:{
      titlePopup:'Are you sure you want to delete',
      titlePopupTrial:'Would you like to try it? ?',
      subtitle:'You cannot undo this action',
      accept:'Accept',
      accept2:'Accept',
      close:'Close',
     },
    rules:{
      textThanks:'Thank you for your interest and access to Info247. We respect and are committed to protecting your privacy. Please read Info247\'s Terms of Use below to better understand the commitments we make to respect and protect the rights of our visitors.',
      textConfirm:'Accept the terms',
      textSubConfirm:'Info247 provides its Services (as defined below) to You through its website at Info247.vn ("Site"), subject to the Conditions. By accepting the Terms or by accessing or using the Services or the Website, You acknowledge and acknowledge that You have read, understood and agreed to be bound by these Terms and that the information you provide when registering for the Service is accurate, complete , and yours or in your use rights. If you are acting on behalf of a company or another legal person, You represent that You have the right to bind that physical and its affiliates to these Terms, in this case, the terms "You", "Yours" or related capitally capitaled terms herein will refer to that party and its affiliates. If You do not have such authority, or if You do not agree to these Terms, You may not accept these Terms and may not use the Services. You acknowledge that these Terms constitute a contract between You and Info247, even though this is an electronic agreement and does not have the actual signature of You and Info247. You further acknowledge that these Terms govern your use of the Services, except for written appen additions signed by the parties specifically amending these Terms, which will replace any other agreement between You and Info247.',
      textPossibility:'Site availability',
      textSubPossibility:'You acknowledge that there may be disruptions in services or events beyond our control. Although we use the highest efforts to make the Site accessible, the Site is sometimes unavailable for any reason, including, without limitation, periodical maintenance. You understand and acknowledge that due to circumstances both within and out of our control, access to the site may be interrupted, suspended or terminated. You further understand that there may be interruptions to services or events on third-party websites, including, but not limited to, Facebook, Youtube, etc. will affect your use of the Service (defined below) and the repair is beyond our control. Interruption of the Service beyond our control will not serve as a basis for terminating your subscription or requesting a full or part refund of any up-to-back fees.',
      textService:'Service Description',
      textSubService:'The "Services" include (a) the Website, (b) the Info247 Mobile Application and (c) other services provided to You through the Site based on the purchased plan, including all software, data, text, images, audio, video and other content provided through the Site (referred to as "Content"). Any new features added to or enhanced by the Services are also subject to these Terms. Certain new features that are usually offered for free to all registered customers will be offered for free to you. However, the availability of some new features may require payment of additional charges, and Info247 will decide for itself whether access to any other such new feature will require an additional fee. Services may also include basic or extended services based on the purchased plan. Info247 will use commercially reasonable efforts to provide the Services available in the applicable Service plan, except: (a) the expected downtime or (b) any unavailable status due to cases beyond our reasonable control. to, acts of religion, government activity, acts of terrorism or civil unrest, or technical failures beyond our control.',
      textAppPhone:'Mobile apps',
      textSubAppPhone:'Info247 provides a mobile app that accesses the Service via mobile devices. To use the Mobile App You must have a mobile device compatible with the mobile service. We don\'t guarantee that the Mobile App will be compatible with your mobile device. Info247 grants You a non-exclusive, non-transferable, rescindable license to use a copy of the Mobile App\'s object code for a registered account on a mobile device owned or leased by you. You must not: (i) modify, remove, debug or reverse the mobile app design; (ii) rent, lease, resell, sub-license, distribute or transfer the Mobile Application to any third party or use the Mobile App to share time or similar services with any third party; (iii) make any copies of the Mobile Application; (iv) remove, circumvent, disable, damage or interfere with the security-related features of the Mobile Application, features that prevent or restrict the use or copy of any content accessible through the Mobile Application or the Application features; or (v) remove copyright and other ownership notices on the Mobile App. You acknowledge that we may occasionally release an upgraded version of the Mobile App and may automatically upgrade the version of the mobile app you\'re using on your mobile device. You agree to such automatic upgrades on your mobile device and agree that these Terms will apply to all such upgrades. The a above-said licensing is not the sale of the Mobile Application or any copy, and Info247 and its third party licensees or providers retain all rights, titles and benefits in and for the Mobile Application (and any copies of the Mobile Application). Standard service provider data charges may apply to your use of the Mobile App. The following additional terms and conditions apply to any Mobile Application that Info247 provides to you designed for use on a mobile device supported by Apple iOS ("iOS App"): You acknowledge that these Terms are only between You and Info247 and not with Apple , Inc. ("Apple"). Your use of the iOS App is subject to the terms of service of the current Apple App Store. Info247, and not Apple, is solely responsible for the iOS App and the services and content available on it. You acknowledge that Apple is not obliged to provide maintenance and support services in connection with our iOS App. To the maximum permitted by applicable law, Apple shall have no warranty obligation for the iOS App. You agree that Info247, and not Apple, is responsible for resolving any claims made by You or any third party relating to the iOS App or your possession and/or use of the iOS App, including, but not limited to: (i) product liability statements; (ii) any claim that the iOS App does not comply with any applicable legal or regulatory requirements; and (iii) claims in place to protect consumers or similar laws and all such claims are governed only by these Terms and any laws applicable to us as iOS App providers. You agree that Info247, and not Apple, shall be liable, to the fullness required by these Terms, to investigate, defend, resolve and lift any claims of third-party intellectual property infringement in connection with the iOS App or your ownership and use of the iOS App. You declare and warrant that (i) You do not live in a country subject to sanctions by the Government of Vietnam or have been identified by the Government of Vietnam as a "terrorist supporting" country; and (ii) You are not listed on the List of Prohibited or Restricted Parties by the Government of Vietnam. You agree to comply with all applicable third-party agreement terms when using the iOS App (for example, you must not violate your wireless data service terms when using the iOS App). You agree that apple and Apple subsidiaries are third party beneficiaries of these Terms as they relate to your license to the iOS App. When you accept these Terms, Apple will have the right (and will be deemed to have accepted the right) to enforce these Terms against You as they relate to your License to the iOS App as a third party beneficiary. The following additional terms and conditions apply to any Mobile Application that Info247™ provides to you designed for use on Android-supported mobile devices ("Android Apps"): You acknowledge that these Terms are between you and only Info247 and not with Google , Inc. ("Google"). Your use of the Android App is subject to the current Google Android Market Terms of Service. Google is just a provider of Android Market where you get android apps',
      textPay:'Pay, modify plans, and pay',
      textSubPay:'Insize and pay. If there is no other agreement in writing by Info247, the service will be provided as soon as you pay and charged at the beginning of the Subscription Term (usually monthly or annually). If you don\'t provide other payment renewal information to Info247 before the end of the free trial period, your account will be suspended until billing information is provided. Modify your subscription. If you choose to upgrade your plan or number of users during your subscription period, any increased costs will be calculated as a percentage of the remainth of your subscription term and charged to your account. You\'ll be charged adjustment fees on the next billing cycles. Downgrading your account may result in loss of your content, features, or ability to account, and Info247 does not accept any liability for such loss. Overdue fees. If you don\'t pay your subscription fee correctly and you don\'t notify us of your payment plan, your entire subscription may be suspended or cancelled. Even after your subscription is suspended or cancelled, you can contact us to restore access to the Services by providing the appropriate payment source. After your subscription is terminated, we will keep your current account settings for 90 days. After that time, Info247 reserves the right to remove such settings from our servers without liability or notice to you.',
      textWisdom:'Intellectual property rights',
      textSubWisdom:'A. Info247\'s other product and service names and other products used or displayed on the Service are registered or uns registered trademarks of Info247, and you may only use such trademarks to identify yourself as a customer and user of the Services. Currently and in the future, you will not be allowed to take a trademark or impair the distinctiveity of the trademark, or use it to tamper with or penetrate Info247, its services or products. B. All rights, rights and interests in and to the Services and its components, including all related intellectual property rights, shall remain under and exclusive to Info247. C. Process of reporting copyright infringement. If the User believes that any of his content, materials, images, videos or other materials provided through the Info247 Service is being infringing on intellectual property rights, please notify us of copyright infringement in accordance with the specific process set out below : (1) We will handle each copyright infringement notice we receive and handle in accordance with the laws of intellectual property; (2) To help us have sufficient facilities to meet your requirements, please send a written notice with the following information; (a) The true signature of the authorized person on behalf of the owner of an exclusive product; (b) A description of the copyrighted work that you decried; (c) A description of where the documents you decried are on the Info247 Services sufficient to allow Info247 to locate it; (d) Your contact information such as address, phone number, email so Info247 can contact you; (e) You represent that you believe that the use of such content is not permitted by the copyright owner, exclusive agent or the law; (f) You declare that the information in your notice is accurate and that you accept the penalty for perjury for which you are authorized to act on behalf of the copyright owner. If the Info247 account is infringing on intellectual property through the User\'s notification, if the results show that the Account has a violation, it is up to Info247 to decide t',
      textSignUp:'Sign up for an account',
      textSubSingUp:'A. In accordance with the terms and conditions of these Terms, You agree to access and use the Services only for your internal business purposes as set out by these Terms. To use the Services, you must register for our services and you will be charged a subscription fee to use the Service after the expiration or termination of any free trial account. Subscription fees, after the expiration or termination of any free trial account, must be prepaid to use the Service. B. If You add Users to your account, you will be solely responsible for any violations of these Terms by your Users. By adding any User to your account, You warrant that: (i) You have received all necessary authorizations, consent of such User to comply with this Agreement. You are solely and solely responsible for any actions and omissions of your Users and You agree to indemnity Info247 for all claims and losses in connection with any actions and/or omissions. C. To be eligible to use the Service, you must meet the following criteria and declare and ensure that you: (1) be 18 years of age or older; (2) is not currently restricted by the Service, or is not prohibited from having an Info247.vn account, (3) not being a competitor to Info247 or not using the Service for reasons that compete with Info247; (4) have full powers and authority to enter into this Agreement and doing so will not violate any other agreement you are currently involved in; (5) will not in breach of any rights of Info247, including intellectual property rights such as copyright or trademarks; and (6) agree to provide your costs for all equipment, software and internet access necessary to use the Service.',
      textUseService:'Use the service',
      textSubUseService:'A. You are not permitted and do not allow, encourage or encourage any third party (including any User) (a) license, sub-license, sell, resell, lease, lease, assign, distribute Info247 to any other user, (b) use the Service to process data on behalf of any third party , (c) modify, modify or attack the Translate or attempt to unauthorized access to the Service; (d) use the Service in any way that is unlawful, violates people\'s privacy, violates anyone\'s intellectual property rights, or sends spam or duplicate messages or is not required to violate applicable law, (e) use the Service in any way that impedes or disrupts the integrity or performance of the Service services and components of the Service; (f) attempt to decrypt, decrypt, reverse engineer or discover the source code of any software that makes up the Service; (g) use the Service to intentionally post, upload, link, send or store any illegal, racist, hateful, pornographic, discriminating or containing any viruses, malware, time bombs or any other similar harm to the software; (h) attempt to use any method for unauthorized access to any paid features of the Site; (i) use automated scripts to collect information from or interact with the Site or Services; (j) a deep link to the Site for any purpose (except Info247\'s homepage), unless explicitly authorized in writing by Info247; (k) impersonate any other user of the Service; or (m) attempt to use or use the Services in violation of these Terms. B. You are responsible for all information, data, text, messages or other materials that You or your Users post or transmit through the Service. You are responsible for maintaining the confidentiality of your logins and accounts and are solely responsible for any and all activities that occur below or in connection with your login or account information. You agree and acknowledge that your Login can only be used by one person and you will not share a single login between multiple people. You agree that You will not sell, exchange or transfer your login or account information to another party, unless specifically agreed in writing by Info247. You agree that you are responsible for anything that occurs through your account, including the behaviors or omissions of your Users.',
      textSecurity:'Data security and security',
      textSubSecurity:'A. When providing You with the Services, We will maintain appropriate safeguards to protect the security, security and integrity of your data and the personal data of your end users. We agree to immediately notify you in the event that Info247 knows or has reason to believe that any person or organization has violated Info247\'s measures or gained unauthorized access to your data ("Information Security Breach"). In the event of any such findings, we will: (a) investigate and mitigate the impact of an Information Security Breach, (b) use our best efforts to ensure that it will not recur, and (c) assist You in remedying this. We will use commercially reasonable efforts to promptly process Your requests and requests in connection with the processing of your data. B. You agree that Info247 may access your account information to meet your service requirements. We will not disclose such data unless required by law, permitted by you, or under the terms of the Info247 Privacy Policy available at Info247.vn and included in these Terms. We agree to store, use, and process your business\'s contact information, including your name, business phone number, and business email address to the full range necessary to provide you with the Services. We will not disclose such business contact information to third parties unless otherwise permitted in writing by you. C. Privacy Policy determines our processing of any information, including personally identified information, that you send to us. You confirm that it is voluntary for you to submit any information, statements, data and content to us.',
      textCancellation:'Cancellation and termination',
      textSubCancellation:'A. You can cancel your account on Info247 at any time; however, you will not be refunded, unless Info247 violates this Agreement and does not remedy the a mentioned breach within thirty (30) days of receiving written notice from You of the actual breach, specifically determining the nature of the breach. We may suspend or cancel your account without notice or refund to you if you violate this Agreement. If your account is cancelled, Info247 reserves the right to delete your account information along with any account settings from our servers without liability or notice to you. When your account information and account settings are deleted, You will not be able to recover this data, and You will lose access to all your content (except for content stored/published for third-party websites, such data will remain the same as the sites in accordance with the terms and conditions of that website). If you cancel the service before the end of your current paid subscription period, your cancellation will take effect immediately. B. Info247 reserves the right (i) to modify or discontinue, temporarily or permanently, the Service (or any part) and (ii) deny any/all use of the Services current and future, suspend or terminate your account and remove and remove any content you have in the Services if we believe you have violated these Terms. Info247 will use reasonable efforts to contact you directly via email to alert you before suspending or terminating your account. Any suspected fraudulent, abusive or illegal activity may be the basis for immediately terminating your use of the Service and may be forwarded to law enforcement. Info247 will not be liable to you or any third party for any modification, suspension or discontinuation of the Services.'
    },
    optionalJob:{
      all:'Tất cả ngành',
      realEstate:'Real estate',
      iT:'IT & Telecommunications',
      insurance:'Insurance',
      freightForwarders:'Freight Forwarders',
      pGovernmentService:'Public & Government Service',
      ecommerce:'Ecommerce',
      pMedical:'Pharmacy & Medical' ,
      construct:'Construct',
      fBanking:'Finance/Banking',
      fBeverages:'Food & Beverages',
      entertain:'Entertain',
      fConsumption:'Fast consumption',
      mAdvertisement:'Media advertisement',
      agriculture:'Agriculture',
      fintech:'Fintech',
      rCommercial:'Retail & Commercial',
      lLegal:'Law/Legal',
      bCHealth:'Beauty, Cosmetics & Health',
      hMotels:'Hotels, motels',
      energy:'Energy',
      travel:'Transport travel',
      education:'Education'
    },
    newspaper: {
      cateLink: 'Link',
      authorXpath: 'Author Xpath',
      contentParentXpath: 'Content Parent Xpath',
      descriptionXpath: 'Description Xpath',
      imageXpath: 'Image Xpath',
      linkDomain: 'Link Domain',
      linksXpath: 'Link Xpath',
      nameDomain: 'Domain',
      textXpath: 'Content Xpath',
      timeRegex: 'Time Regex',
      timeXpath: 'Time Xpath',
      titleXpath: 'Title Xpath',
      deleteConfirmation: 'Are you sure to delete this record?',
      textSuccess: 'Delete record successfully',
      textError: 'Delete record failed',
      btnAdd: 'Add',
      successText: 'Sucessfully',
      failText: 'Failed',
      numberOrder: 'Priority level',
    }
  },
}




